/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /** The day, does not include a time. */
  Date: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
  Email: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /**
   * A JSON Web Token defined by [RFC 7519](https://tools.ietf.org/html/rfc7519)
   * which securely represents claims between two parties.
   */
  JwtToken: any;
  Slug: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any;
};

export type Account = Node & {
  __typename?: 'Account';
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Account`. */
  accountsByOnboardedBy: AccountsConnection;
  /** Reads and enables pagination through a set of `Account`. */
  accountsByReferredBy: AccountsConnection;
  admin?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Alert`. */
  alerts: AlertsConnection;
  amexNotificationSent?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  avatarId?: Maybe<Scalars['UUID']>;
  campaign?: Maybe<Scalars['JSON']>;
  /** Reads a single `Consumer` that is related to this `Account`. */
  consumer?: Maybe<Consumer>;
  /** Reads and enables pagination through a set of `Contact`. */
  contacts: ContactsConnection;
  createdAt: Scalars['Datetime'];
  dashboard?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `DocusignEnvelopeRecipient`. */
  docusignEnvelopeRecipients: DocusignEnvelopeRecipientsConnection;
  email?: Maybe<Scalars['Email']>;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Invitation`. */
  invitations: InvitationsConnection;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitationsByReferred: InvitationsConnection;
  lastName: Scalars['String'];
  /** Reads and enables pagination through a set of `Log`. */
  logs: LogsConnection;
  /** Reads and enables pagination through a set of `Media`. */
  media: MediaConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesFrom: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesTo: MessagesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Note`. */
  notes: NotesConnection;
  onboardedBy?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `OpenaiThread`. */
  openaiThreads: OpenaiThreadsConnection;
  passwordEmpty?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Payment`. */
  payments: PaymentsConnection;
  phone?: Maybe<Scalars['String']>;
  pointsAvailable?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `PointsLedger`. */
  pointsLedger: PointsLedgersConnection;
  /** Reads and enables pagination through a set of `PromoCode`. */
  promoCodes: PromoCodesConnection;
  /** Reads a single `Provider` that is related to this `Account`. */
  provider?: Maybe<Provider>;
  referralCode?: Maybe<Scalars['String']>;
  referredBy?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Review`. */
  reviews: ReviewsConnection;
  /** Reads a single `PromoCode` that is related to this `Account`. */
  signupPromoCode?: Maybe<PromoCode>;
  signupPromoCodeId?: Maybe<Scalars['UUID']>;
  suppressMessages?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `UserActivity`. */
  userActivities: UserActivitiesConnection;
};


export type AccountAccountsByOnboardedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


export type AccountAccountsByReferredByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


export type AccountAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AlertCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AlertsOrderBy>>;
};


export type AccountContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};


export type AccountDocusignEnvelopeRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocusignEnvelopeRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocusignEnvelopeRecipientsOrderBy>>;
};


export type AccountInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


export type AccountInvitationsByReferredArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


export type AccountLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};


export type AccountMediaArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};


export type AccountMessagesFromArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type AccountMessagesToArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type AccountNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AccountOpenaiThreadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiThreadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};


export type AccountPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type AccountPointsLedgerArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointsLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};


export type AccountPromoCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PromoCodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodesOrderBy>>;
};


export type AccountReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};


export type AccountUserActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserActivityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `avatarId` field. */
  avatarId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `onboardedBy` field. */
  onboardedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referredBy` field. */
  referredBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `signupPromoCodeId` field. */
  signupPromoCodeId?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `Account`. Fields that are set will be updated. */
export type AccountPatch = {
  amexNotificationSent?: InputMaybe<Scalars['Boolean']>;
  avatarId?: InputMaybe<Scalars['UUID']>;
  campaign?: InputMaybe<Scalars['JSON']>;
  dashboard?: InputMaybe<Scalars['JSON']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  onboardedBy?: InputMaybe<Scalars['UUID']>;
  referredBy?: InputMaybe<Scalars['UUID']>;
  signupPromoCodeId?: InputMaybe<Scalars['UUID']>;
  suppressMessages?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export enum AccountsOrderBy {
  AvatarIdAsc = 'AVATAR_ID_ASC',
  AvatarIdDesc = 'AVATAR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OnboardedByAsc = 'ONBOARDED_BY_ASC',
  OnboardedByDesc = 'ONBOARDED_BY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferredByAsc = 'REFERRED_BY_ASC',
  ReferredByDesc = 'REFERRED_BY_DESC',
  SignupPromoCodeIdAsc = 'SIGNUP_PROMO_CODE_ID_ASC',
  SignupPromoCodeIdDesc = 'SIGNUP_PROMO_CODE_ID_DESC'
}

/** All input for the `addDealAddress` mutation. */
export type AddDealAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dealUniqueId?: InputMaybe<Scalars['BigFloat']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
};

/** The output of our `addDealAddress` mutation. */
export type AddDealAddressPayload = {
  __typename?: 'AddDealAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `addInquiryAddress` mutation. */
export type AddInquiryAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
};

/** The output of our `addInquiryAddress` mutation. */
export type AddInquiryAddressPayload = {
  __typename?: 'AddInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addInquiryAddress` mutation. */
export type AddInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the `adminUpdateAccount` mutation. */
export type AdminUpdateAccountInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Scalars['JSON'];
};

/** The output of our `adminUpdateAccount` mutation. */
export type AdminUpdateAccountPayload = {
  __typename?: 'AdminUpdateAccountPayload';
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PromoCode` that is related to this `Account`. */
  signupPromoCode?: Maybe<PromoCode>;
};


/** The output of our `adminUpdateAccount` mutation. */
export type AdminUpdateAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

export type Agent = {
  __typename?: 'Agent';
  city?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** A connection to a list of `Agent` values. */
export type AgentsConnection = {
  __typename?: 'AgentsConnection';
  /** A list of edges which contains the `Agent` and cursor to aid in pagination. */
  edges: Array<AgentsEdge>;
  /** A list of `Agent` objects. */
  nodes: Array<Agent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Agent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Agent` edge in the connection. */
export type AgentsEdge = {
  __typename?: 'AgentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Agent` at the end of the edge. */
  node: Agent;
};

export type Alert = Node & {
  __typename?: 'Alert';
  /** Reads a single `Account` that is related to this `Alert`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  readAt?: Maybe<Scalars['Datetime']>;
  type: AlertType;
};

/** A condition to be used against `Alert` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AlertCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Alert` */
export type AlertInput = {
  accountId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message: Scalars['String'];
  readAt?: InputMaybe<Scalars['Datetime']>;
  type?: InputMaybe<AlertType>;
};

/** Represents an update to a `Alert`. Fields that are set will be updated. */
export type AlertPatch = {
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  readAt?: InputMaybe<Scalars['Datetime']>;
};

export enum AlertType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

/** A connection to a list of `Alert` values. */
export type AlertsConnection = {
  __typename?: 'AlertsConnection';
  /** A list of edges which contains the `Alert` and cursor to aid in pagination. */
  edges: Array<AlertsEdge>;
  /** A list of `Alert` objects. */
  nodes: Array<Alert>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Alert` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Alert` edge in the connection. */
export type AlertsEdge = {
  __typename?: 'AlertsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Alert` at the end of the edge. */
  node: Alert;
};

/** Methods to use when ordering `Alert`. */
export enum AlertsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Consumer = Node & {
  __typename?: 'Consumer';
  /** Reads a single `Account` that is related to this `Consumer`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  appointment?: Maybe<Scalars['String']>;
  consultScheduled?: Maybe<Scalars['Boolean']>;
  consultation?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `ConsumerDealAgentsResult`. */
  dealAgents: ConsumerDealAgentsResultsConnection;
  /** Reads and enables pagination through a set of `ConsumerDealsResponse`. */
  deals: ConsumerDealsResponsesConnection;
  deletedAt?: Maybe<Scalars['Datetime']>;
  ebContactType?: Maybe<Scalars['String']>;
  engagebay?: Maybe<Scalars['JSON']>;
  firstConsultDate?: Maybe<Scalars['Datetime']>;
  hasPotentialProviders?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Inquiry`. */
  inquiries: InquiriesConnection;
  kpiWeek?: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection;
  maxPrice?: Maybe<Scalars['BigInt']>;
  nextConnectBy?: Maybe<Scalars['Date']>;
  nextStep?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OpenaiThread`. */
  openaiThreads: OpenaiThreadsConnection;
  /** Reads and enables pagination through a set of `Provider`. */
  potentialProviders: ProvidersConnection;
  providersInArea?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Review`. */
  reviews: ReviewsConnection;
  timeToCall?: Maybe<Scalars['BigFloat']>;
  timeToFirstCall?: Maybe<Scalars['String']>;
  timeToScheduleConsult?: Maybe<Scalars['BigFloat']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  vendors?: Maybe<Scalars['JSON']>;
};


export type ConsumerDealAgentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerDealsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerInquiriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};


export type ConsumerLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerOpenaiThreadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiThreadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};


export type ConsumerPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};

/**
 * A condition to be used against `Consumer` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ConsumerCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `engagebay` field. */
  engagebay?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ConsumerDealAgentsResult = {
  __typename?: 'ConsumerDealAgentsResult';
  dealUniqueId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ConsumerDealAgentsResult`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
  selected?: Maybe<Scalars['Boolean']>;
};

/** A connection to a list of `ConsumerDealAgentsResult` values. */
export type ConsumerDealAgentsResultsConnection = {
  __typename?: 'ConsumerDealAgentsResultsConnection';
  /** A list of edges which contains the `ConsumerDealAgentsResult` and cursor to aid in pagination. */
  edges: Array<ConsumerDealAgentsResultsEdge>;
  /** A list of `ConsumerDealAgentsResult` objects. */
  nodes: Array<ConsumerDealAgentsResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ConsumerDealAgentsResult` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConsumerDealAgentsResult` edge in the connection. */
export type ConsumerDealAgentsResultsEdge = {
  __typename?: 'ConsumerDealAgentsResultsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ConsumerDealAgentsResult` at the end of the edge. */
  node: ConsumerDealAgentsResult;
};

export type ConsumerDealsResponse = {
  __typename?: 'ConsumerDealsResponse';
  /** Reads and enables pagination through a set of `DealAddressesResponse`. */
  addresses: DealAddressesResponsesConnection;
  agent?: Maybe<Provider>;
  agentsPresentedDate?: Maybe<Scalars['Date']>;
  agreementPercent?: Maybe<Scalars['BigFloat']>;
  amount?: Maybe<Scalars['BigFloat']>;
  assistantEmail?: Maybe<Scalars['String']>;
  assistantName?: Maybe<Scalars['String']>;
  closeOfEscrow?: Maybe<Scalars['Date']>;
  closingCompanyContact?: Maybe<Scalars['String']>;
  closingCompanyEmail?: Maybe<Scalars['String']>;
  closingCompanyName?: Maybe<Scalars['String']>;
  closingCompanyPhone?: Maybe<Scalars['String']>;
  commissionSplit?: Maybe<Scalars['BigFloat']>;
  connectToAgentBy?: Maybe<Scalars['Date']>;
  /** Reads a single `Consumer` that is related to this `ConsumerDealsResponse`. */
  consumer?: Maybe<Consumer>;
  consumerId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['BigFloat']>;
  inviteEnabled?: Maybe<Scalars['Boolean']>;
  kpiWeek?: Maybe<Scalars['Date']>;
  location?: Maybe<Scalars['String']>;
  milestone?: Maybe<Scalars['String']>;
  milestoneHistory?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  paymentAmount?: Maybe<Scalars['BigFloat']>;
  paymentIssuer?: Maybe<Scalars['String']>;
  paymentReceived?: Maybe<Scalars['Date']>;
  pointsEstimate?: Maybe<Scalars['BigFloat']>;
  pointsEstimateEmailSent?: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `DealPresentAgentsResponse`. */
  presentAgents: DealPresentAgentsResponsesConnection;
  priceRange?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  selectedAgent?: Maybe<Scalars['String']>;
  side?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  timeToMatch?: Maybe<Scalars['BigFloat']>;
  track?: Maybe<Scalars['String']>;
  uniqueId?: Maybe<Scalars['BigFloat']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ConsumerDealsResponseAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerDealsResponsePresentAgentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ConsumerDealsResponse` values. */
export type ConsumerDealsResponsesConnection = {
  __typename?: 'ConsumerDealsResponsesConnection';
  /** A list of edges which contains the `ConsumerDealsResponse` and cursor to aid in pagination. */
  edges: Array<ConsumerDealsResponsesEdge>;
  /** A list of `ConsumerDealsResponse` objects. */
  nodes: Array<ConsumerDealsResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ConsumerDealsResponse` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConsumerDealsResponse` edge in the connection. */
export type ConsumerDealsResponsesEdge = {
  __typename?: 'ConsumerDealsResponsesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ConsumerDealsResponse` at the end of the edge. */
  node: ConsumerDealsResponse;
};

/** Represents an update to a `Consumer`. Fields that are set will be updated. */
export type ConsumerPatch = {
  consultation?: InputMaybe<Scalars['JSON']>;
  engagebay?: InputMaybe<Scalars['JSON']>;
  providersInArea?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  vendors?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `Consumer` values. */
export type ConsumersConnection = {
  __typename?: 'ConsumersConnection';
  /** A list of edges which contains the `Consumer` and cursor to aid in pagination. */
  edges: Array<ConsumersEdge>;
  /** A list of `Consumer` objects. */
  nodes: Array<Consumer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Consumer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Consumer` edge in the connection. */
export type ConsumersEdge = {
  __typename?: 'ConsumersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Consumer` at the end of the edge. */
  node: Consumer;
};

/** Methods to use when ordering `Consumer`. */
export enum ConsumersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  EngagebayAsc = 'ENGAGEBAY_ASC',
  EngagebayDesc = 'ENGAGEBAY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Contact = Node & {
  __typename?: 'Contact';
  /** Reads a single `Account` that is related to this `Contact`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type: Scalars['String'];
  undeliverableAt?: Maybe<Scalars['Datetime']>;
  unsubscribedAt?: Maybe<Scalars['Datetime']>;
  value: Scalars['JSON'];
  verificationAttempts?: Maybe<Scalars['Int']>;
  verificationCodeSent?: Maybe<Scalars['Datetime']>;
  verifiedAt?: Maybe<Scalars['Datetime']>;
};

/** A condition to be used against `Contact` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ContactCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** An input for mutations affecting `Contact` */
export type ContactInput = {
  type: Scalars['String'];
  value: Scalars['JSON'];
};

/** All input for the `contactUs` mutation. */
export type ContactUsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** The output of our `contactUs` mutation. */
export type ContactUsPayload = {
  __typename?: 'ContactUsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Contact` values. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of edges which contains the `Contact` and cursor to aid in pagination. */
  edges: Array<ContactsEdge>;
  /** A list of `Contact` objects. */
  nodes: Array<Contact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Contact` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Contact` edge in the connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Contact` at the end of the edge. */
  node: Contact;
};

/** Methods to use when ordering `Contact`. */
export enum ContactsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** All input for the `createAccountReferralCode` mutation. */
export type CreateAccountReferralCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `createAccountReferralCode` mutation. */
export type CreateAccountReferralCodePayload = {
  __typename?: 'CreateAccountReferralCodePayload';
  /** Reads a single `Account` that is related to this `PromoCode`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Account` that is related to this `PromoCode`. */
  creator?: Maybe<Account>;
  /** Reads a single `PromoCode` that is related to this `PromoCode`. */
  parent?: Maybe<PromoCode>;
  promoCode?: Maybe<PromoCode>;
  /** An edge for our `PromoCode`. May be used by Relay 1. */
  promoCodeEdge?: Maybe<PromoCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createAccountReferralCode` mutation. */
export type CreateAccountReferralCodePayloadPromoCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PromoCodesOrderBy>>;
};

/** All input for the create `Alert` mutation. */
export type CreateAlertInput = {
  /** The `Alert` to be created by this mutation. */
  alert: AlertInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Alert` mutation. */
export type CreateAlertPayload = {
  __typename?: 'CreateAlertPayload';
  /** Reads a single `Account` that is related to this `Alert`. */
  account?: Maybe<Account>;
  /** The `Alert` that was created by this mutation. */
  alert?: Maybe<Alert>;
  /** An edge for our `Alert`. May be used by Relay 1. */
  alertEdge?: Maybe<AlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Alert` mutation. */
export type CreateAlertPayloadAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<AlertsOrderBy>>;
};

/** All input for the create `Contact` mutation. */
export type CreateContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Contact` to be created by this mutation. */
  contact: ContactInput;
};

/** The output of our create `Contact` mutation. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** Reads a single `Account` that is related to this `Contact`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contact` that was created by this mutation. */
  contact?: Maybe<Contact>;
  /** An edge for our `Contact`. May be used by Relay 1. */
  contactEdge?: Maybe<ContactsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Contact` mutation. */
export type CreateContactPayloadContactEdgeArgs = {
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};

/** All input for the create `ExternalLead` mutation. */
export type CreateExternalLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalLead` to be created by this mutation. */
  externalLead: ExternalLeadInput;
};

/** The output of our create `ExternalLead` mutation. */
export type CreateExternalLeadPayload = {
  __typename?: 'CreateExternalLeadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalLead` that was created by this mutation. */
  externalLead?: Maybe<ExternalLead>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `InquiryAddress` mutation. */
export type CreateInquiryAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `InquiryAddress` to be created by this mutation. */
  inquiryAddress: InquiryAddressInput;
};

/** The output of our create `InquiryAddress` mutation. */
export type CreateInquiryAddressPayload = {
  __typename?: 'CreateInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  /** The `InquiryAddress` that was created by this mutation. */
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InquiryAddress` mutation. */
export type CreateInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the create `Inquiry` mutation. */
export type CreateInquiryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Inquiry` to be created by this mutation. */
  inquiry: InquiryInput;
};

/** The output of our create `Inquiry` mutation. */
export type CreateInquiryPayload = {
  __typename?: 'CreateInquiryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Inquiry`. */
  consumer?: Maybe<Consumer>;
  /** The `Inquiry` that was created by this mutation. */
  inquiry?: Maybe<Inquiry>;
  /** An edge for our `Inquiry`. May be used by Relay 1. */
  inquiryEdge?: Maybe<InquiriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Inquiry` mutation. */
export type CreateInquiryPayloadInquiryEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};

/** All input for the create `Invitation` mutation. */
export type CreateInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Invitation` to be created by this mutation. */
  invitation: InvitationInput;
};

/** The output of our create `Invitation` mutation. */
export type CreateInvitationPayload = {
  __typename?: 'CreateInvitationPayload';
  /** Reads a single `Account` that is related to this `Invitation`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Invitation`. */
  accountByReferred?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Invitation` that was created by this mutation. */
  invitation?: Maybe<Invitation>;
  /** An edge for our `Invitation`. May be used by Relay 1. */
  invitationEdge?: Maybe<InvitationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Invitation` mutation. */
export type CreateInvitationPayloadInvitationEdgeArgs = {
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};

/** All input for the create `Lead` mutation. */
export type CreateLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Lead` to be created by this mutation. */
  lead: LeadInput;
};

/** The output of our create `Lead` mutation. */
export type CreateLeadPayload = {
  __typename?: 'CreateLeadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `Lead`. */
  inquiry?: Maybe<Inquiry>;
  /** The `Lead` that was created by this mutation. */
  lead?: Maybe<Lead>;
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>;
  /** Reads a single `Provider` that is related to this `Lead`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Lead` mutation. */
export type CreateLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};

/** All input for the create `License` mutation. */
export type CreateLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `License` to be created by this mutation. */
  license: LicenseInput;
};

/** The output of our create `License` mutation. */
export type CreateLicensePayload = {
  __typename?: 'CreateLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `License` that was created by this mutation. */
  license?: Maybe<License>;
  /** An edge for our `License`. May be used by Relay 1. */
  licenseEdge?: Maybe<LicensesEdge>;
  /** Reads a single `Provider` that is related to this `License`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `License` mutation. */
export type CreateLicensePayloadLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<LicensesOrderBy>>;
};

/** All input for the create `Log` mutation. */
export type CreateLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Log` to be created by this mutation. */
  log: LogInput;
};

/** The output of our create `Log` mutation. */
export type CreateLogPayload = {
  __typename?: 'CreateLogPayload';
  /** Reads a single `Account` that is related to this `Log`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Log` that was created by this mutation. */
  log?: Maybe<Log>;
  /** An edge for our `Log`. May be used by Relay 1. */
  logEdge?: Maybe<LogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Log` mutation. */
export type CreateLogPayloadLogEdgeArgs = {
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};

/** All input for the create `Note` mutation. */
export type CreateNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Note` to be created by this mutation. */
  note: NoteInput;
};

/** The output of our create `Note` mutation. */
export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  /** Reads a single `Account` that is related to this `Note`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Note` that was created by this mutation. */
  note?: Maybe<Note>;
  /** An edge for our `Note`. May be used by Relay 1. */
  noteEdge?: Maybe<NotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Note` mutation. */
export type CreateNotePayloadNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};

/** All input for the create `OpenaiAssistant` mutation. */
export type CreateOpenaiAssistantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OpenaiAssistant` to be created by this mutation. */
  openaiAssistant: OpenaiAssistantInput;
};

/** The output of our create `OpenaiAssistant` mutation. */
export type CreateOpenaiAssistantPayload = {
  __typename?: 'CreateOpenaiAssistantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiAssistant` that was created by this mutation. */
  openaiAssistant?: Maybe<OpenaiAssistant>;
  /** An edge for our `OpenaiAssistant`. May be used by Relay 1. */
  openaiAssistantEdge?: Maybe<OpenaiAssistantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OpenaiAssistant` mutation. */
export type CreateOpenaiAssistantPayloadOpenaiAssistantEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiAssistantsOrderBy>>;
};

/** All input for the create `OpenaiMessage` mutation. */
export type CreateOpenaiMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OpenaiMessage` to be created by this mutation. */
  openaiMessage: OpenaiMessageInput;
};

/** The output of our create `OpenaiMessage` mutation. */
export type CreateOpenaiMessagePayload = {
  __typename?: 'CreateOpenaiMessagePayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiMessage`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiMessage` that was created by this mutation. */
  openaiMessage?: Maybe<OpenaiMessage>;
  /** An edge for our `OpenaiMessage`. May be used by Relay 1. */
  openaiMessageEdge?: Maybe<OpenaiMessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiRun` that is related to this `OpenaiMessage`. */
  run?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiMessage`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our create `OpenaiMessage` mutation. */
export type CreateOpenaiMessagePayloadOpenaiMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};

/** All input for the create `OpenaiRun` mutation. */
export type CreateOpenaiRunInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OpenaiRun` to be created by this mutation. */
  openaiRun: OpenaiRunInput;
};

/** The output of our create `OpenaiRun` mutation. */
export type CreateOpenaiRunPayload = {
  __typename?: 'CreateOpenaiRunPayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRun`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiRun` that was created by this mutation. */
  openaiRun?: Maybe<OpenaiRun>;
  /** An edge for our `OpenaiRun`. May be used by Relay 1. */
  openaiRunEdge?: Maybe<OpenaiRunsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRun`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our create `OpenaiRun` mutation. */
export type CreateOpenaiRunPayloadOpenaiRunEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};

/** All input for the create `OpenaiRunStep` mutation. */
export type CreateOpenaiRunStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OpenaiRunStep` to be created by this mutation. */
  openaiRunStep: OpenaiRunStepInput;
};

/** The output of our create `OpenaiRunStep` mutation. */
export type CreateOpenaiRunStepPayload = {
  __typename?: 'CreateOpenaiRunStepPayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRunStep`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiRunStep` that was created by this mutation. */
  openaiRunStep?: Maybe<OpenaiRunStep>;
  /** An edge for our `OpenaiRunStep`. May be used by Relay 1. */
  openaiRunStepEdge?: Maybe<OpenaiRunStepsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiRun` that is related to this `OpenaiRunStep`. */
  run?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRunStep`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our create `OpenaiRunStep` mutation. */
export type CreateOpenaiRunStepPayloadOpenaiRunStepEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};

/** All input for the create `OpenaiThread` mutation. */
export type CreateOpenaiThreadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OpenaiThread` to be created by this mutation. */
  openaiThread: OpenaiThreadInput;
};

/** The output of our create `OpenaiThread` mutation. */
export type CreateOpenaiThreadPayload = {
  __typename?: 'CreateOpenaiThreadPayload';
  /** Reads a single `Account` that is related to this `OpenaiThread`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `OpenaiThread`. */
  consumer?: Maybe<Consumer>;
  /** The `OpenaiThread` that was created by this mutation. */
  openaiThread?: Maybe<OpenaiThread>;
  /** An edge for our `OpenaiThread`. May be used by Relay 1. */
  openaiThreadEdge?: Maybe<OpenaiThreadsEdge>;
  /** Reads a single `Provider` that is related to this `OpenaiThread`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OpenaiThread` mutation. */
export type CreateOpenaiThreadPayloadOpenaiThreadEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};

/** All input for the create `Payment` mutation. */
export type CreatePaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Payment` to be created by this mutation. */
  payment: PaymentInput;
};

/** The output of our create `Payment` mutation. */
export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  /** Reads a single `Account` that is related to this `Payment`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Payment` that was created by this mutation. */
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Payment` mutation. */
export type CreatePaymentPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the create `PointsLedger` mutation. */
export type CreatePointsLedgerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PointsLedger` to be created by this mutation. */
  pointsLedger: PointsLedgerInput;
};

/** The output of our create `PointsLedger` mutation. */
export type CreatePointsLedgerPayload = {
  __typename?: 'CreatePointsLedgerPayload';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PointsLedger` that was created by this mutation. */
  pointsLedger?: Maybe<PointsLedger>;
  /** An edge for our `PointsLedger`. May be used by Relay 1. */
  pointsLedgerEdge?: Maybe<PointsLedgersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PointsLedger` mutation. */
export type CreatePointsLedgerPayloadPointsLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};

/** All input for the create `PromoCode` mutation. */
export type CreatePromoCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PromoCode` to be created by this mutation. */
  promoCode: PromoCodeInput;
};

/** The output of our create `PromoCode` mutation. */
export type CreatePromoCodePayload = {
  __typename?: 'CreatePromoCodePayload';
  /** Reads a single `Account` that is related to this `PromoCode`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Account` that is related to this `PromoCode`. */
  creator?: Maybe<Account>;
  /** Reads a single `PromoCode` that is related to this `PromoCode`. */
  parent?: Maybe<PromoCode>;
  /** The `PromoCode` that was created by this mutation. */
  promoCode?: Maybe<PromoCode>;
  /** An edge for our `PromoCode`. May be used by Relay 1. */
  promoCodeEdge?: Maybe<PromoCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PromoCode` mutation. */
export type CreatePromoCodePayloadPromoCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PromoCodesOrderBy>>;
};

/** All input for the create `ProviderTransaction` mutation. */
export type CreateProviderTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProviderTransaction` to be created by this mutation. */
  providerTransaction: ProviderTransactionInput;
};

/** The output of our create `ProviderTransaction` mutation. */
export type CreateProviderTransactionPayload = {
  __typename?: 'CreateProviderTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  /** The `ProviderTransaction` that was created by this mutation. */
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProviderTransaction` mutation. */
export type CreateProviderTransactionPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** All input for the create `Redirect` mutation. */
export type CreateRedirectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Redirect` to be created by this mutation. */
  redirect: RedirectInput;
};

/** The output of our create `Redirect` mutation. */
export type CreateRedirectPayload = {
  __typename?: 'CreateRedirectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Redirect` that was created by this mutation. */
  redirect?: Maybe<Redirect>;
  /** An edge for our `Redirect`. May be used by Relay 1. */
  redirectEdge?: Maybe<RedirectsEdge>;
};


/** The output of our create `Redirect` mutation. */
export type CreateRedirectPayloadRedirectEdgeArgs = {
  orderBy?: InputMaybe<Array<RedirectsOrderBy>>;
};

/** All input for the `createReferralCode` mutation. */
export type CreateReferralCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `createReferralCode` mutation. */
export type CreateReferralCodePayload = {
  __typename?: 'CreateReferralCodePayload';
  /** Reads a single `Account` that is related to this `PromoCode`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Account` that is related to this `PromoCode`. */
  creator?: Maybe<Account>;
  /** Reads a single `PromoCode` that is related to this `PromoCode`. */
  parent?: Maybe<PromoCode>;
  promoCode?: Maybe<PromoCode>;
  /** An edge for our `PromoCode`. May be used by Relay 1. */
  promoCodeEdge?: Maybe<PromoCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createReferralCode` mutation. */
export type CreateReferralCodePayloadPromoCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PromoCodesOrderBy>>;
};

/** All input for the create `Review` mutation. */
export type CreateReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Review` to be created by this mutation. */
  review: ReviewInput;
};

/** The output of our create `Review` mutation. */
export type CreateReviewPayload = {
  __typename?: 'CreateReviewPayload';
  /** Reads a single `Account` that is related to this `Review`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Review`. */
  consumer?: Maybe<Consumer>;
  /** Reads a single `Provider` that is related to this `Review`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Review` that was created by this mutation. */
  review?: Maybe<Review>;
  /** An edge for our `Review`. May be used by Relay 1. */
  reviewEdge?: Maybe<ReviewsEdge>;
};


/** The output of our create `Review` mutation. */
export type CreateReviewPayloadReviewEdgeArgs = {
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};

/** All input for the create `UserActivity` mutation. */
export type CreateUserActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserActivity` to be created by this mutation. */
  userActivity: UserActivityInput;
};

/** The output of our create `UserActivity` mutation. */
export type CreateUserActivityPayload = {
  __typename?: 'CreateUserActivityPayload';
  /** Reads a single `Account` that is related to this `UserActivity`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserActivity` that was created by this mutation. */
  userActivity?: Maybe<UserActivity>;
  /** An edge for our `UserActivity`. May be used by Relay 1. */
  userActivityEdge?: Maybe<UserActivitiesEdge>;
};


/** The output of our create `UserActivity` mutation. */
export type CreateUserActivityPayloadUserActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};

export type DealAddressesResponse = {
  __typename?: 'DealAddressesResponse';
  address?: Maybe<Scalars['String']>;
  dealUniqueId?: Maybe<Scalars['BigFloat']>;
  id?: Maybe<Scalars['UUID']>;
  latitude?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `DealAddressesResponse` values. */
export type DealAddressesResponsesConnection = {
  __typename?: 'DealAddressesResponsesConnection';
  /** A list of edges which contains the `DealAddressesResponse` and cursor to aid in pagination. */
  edges: Array<DealAddressesResponsesEdge>;
  /** A list of `DealAddressesResponse` objects. */
  nodes: Array<DealAddressesResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DealAddressesResponse` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DealAddressesResponse` edge in the connection. */
export type DealAddressesResponsesEdge = {
  __typename?: 'DealAddressesResponsesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DealAddressesResponse` at the end of the edge. */
  node: DealAddressesResponse;
};

export type DealPresentAgentsResponse = {
  __typename?: 'DealPresentAgentsResponse';
  bio?: Maybe<Scalars['String']>;
  blurb?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['BigFloat']>;
  email?: Maybe<Scalars['Email']>;
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  introduced?: Maybe<Scalars['Datetime']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `DealPresentAgentsResponse`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
  rating?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `DealPresentAgentsResponse` values. */
export type DealPresentAgentsResponsesConnection = {
  __typename?: 'DealPresentAgentsResponsesConnection';
  /** A list of edges which contains the `DealPresentAgentsResponse` and cursor to aid in pagination. */
  edges: Array<DealPresentAgentsResponsesEdge>;
  /** A list of `DealPresentAgentsResponse` objects. */
  nodes: Array<DealPresentAgentsResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DealPresentAgentsResponse` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DealPresentAgentsResponse` edge in the connection. */
export type DealPresentAgentsResponsesEdge = {
  __typename?: 'DealPresentAgentsResponsesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DealPresentAgentsResponse` at the end of the edge. */
  node: DealPresentAgentsResponse;
};

/** All input for the `deleteAlert` mutation. */
export type DeleteAlertInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our `deleteAlert` mutation. */
export type DeleteAlertPayload = {
  __typename?: 'DeleteAlertPayload';
  alerts?: Maybe<Array<Alert>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteContact` mutation. */
export type DeleteContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
};

/** The output of our `deleteContact` mutation. */
export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Contact>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteDealAddress` mutation. */
export type DeleteDealAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `deleteDealAddress` mutation. */
export type DeleteDealAddressPayload = {
  __typename?: 'DeleteDealAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteInquiryAddressById` mutation. */
export type DeleteInquiryAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteInquiryAddress` mutation. */
export type DeleteInquiryAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InquiryAddress` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `InquiryAddress` mutation. */
export type DeleteInquiryAddressPayload = {
  __typename?: 'DeleteInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInquiryAddressId?: Maybe<Scalars['ID']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  /** The `InquiryAddress` that was deleted by this mutation. */
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `InquiryAddress` mutation. */
export type DeleteInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the `deleteMedia` mutation. */
export type DeleteMediaInput = {
  _id: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteMedia` mutation. */
export type DeleteMediaPayload = {
  __typename?: 'DeleteMediaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Media>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteNote` mutation. */
export type DeleteNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our `deleteNote` mutation. */
export type DeleteNotePayload = {
  __typename?: 'DeleteNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Note>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteOpenaiAssistantById` mutation. */
export type DeleteOpenaiAssistantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `deleteOpenaiAssistant` mutation. */
export type DeleteOpenaiAssistantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiAssistant` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `OpenaiAssistant` mutation. */
export type DeleteOpenaiAssistantPayload = {
  __typename?: 'DeleteOpenaiAssistantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOpenaiAssistantId?: Maybe<Scalars['ID']>;
  /** The `OpenaiAssistant` that was deleted by this mutation. */
  openaiAssistant?: Maybe<OpenaiAssistant>;
  /** An edge for our `OpenaiAssistant`. May be used by Relay 1. */
  openaiAssistantEdge?: Maybe<OpenaiAssistantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OpenaiAssistant` mutation. */
export type DeleteOpenaiAssistantPayloadOpenaiAssistantEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiAssistantsOrderBy>>;
};

/** All input for the `deleteOpenaiMessageById` mutation. */
export type DeleteOpenaiMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `deleteOpenaiMessage` mutation. */
export type DeleteOpenaiMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiMessage` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `OpenaiMessage` mutation. */
export type DeleteOpenaiMessagePayload = {
  __typename?: 'DeleteOpenaiMessagePayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiMessage`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOpenaiMessageId?: Maybe<Scalars['ID']>;
  /** The `OpenaiMessage` that was deleted by this mutation. */
  openaiMessage?: Maybe<OpenaiMessage>;
  /** An edge for our `OpenaiMessage`. May be used by Relay 1. */
  openaiMessageEdge?: Maybe<OpenaiMessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiRun` that is related to this `OpenaiMessage`. */
  run?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiMessage`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our delete `OpenaiMessage` mutation. */
export type DeleteOpenaiMessagePayloadOpenaiMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};

/** All input for the `deleteOpenaiRunById` mutation. */
export type DeleteOpenaiRunByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `deleteOpenaiRun` mutation. */
export type DeleteOpenaiRunInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiRun` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `OpenaiRun` mutation. */
export type DeleteOpenaiRunPayload = {
  __typename?: 'DeleteOpenaiRunPayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRun`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOpenaiRunId?: Maybe<Scalars['ID']>;
  /** The `OpenaiRun` that was deleted by this mutation. */
  openaiRun?: Maybe<OpenaiRun>;
  /** An edge for our `OpenaiRun`. May be used by Relay 1. */
  openaiRunEdge?: Maybe<OpenaiRunsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRun`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our delete `OpenaiRun` mutation. */
export type DeleteOpenaiRunPayloadOpenaiRunEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};

/** All input for the `deleteOpenaiRunStepById` mutation. */
export type DeleteOpenaiRunStepByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `deleteOpenaiRunStep` mutation. */
export type DeleteOpenaiRunStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiRunStep` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `OpenaiRunStep` mutation. */
export type DeleteOpenaiRunStepPayload = {
  __typename?: 'DeleteOpenaiRunStepPayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRunStep`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOpenaiRunStepId?: Maybe<Scalars['ID']>;
  /** The `OpenaiRunStep` that was deleted by this mutation. */
  openaiRunStep?: Maybe<OpenaiRunStep>;
  /** An edge for our `OpenaiRunStep`. May be used by Relay 1. */
  openaiRunStepEdge?: Maybe<OpenaiRunStepsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiRun` that is related to this `OpenaiRunStep`. */
  run?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRunStep`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our delete `OpenaiRunStep` mutation. */
export type DeleteOpenaiRunStepPayloadOpenaiRunStepEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};

/** All input for the `deleteOpenaiThreadById` mutation. */
export type DeleteOpenaiThreadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `deleteOpenaiThread` mutation. */
export type DeleteOpenaiThreadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiThread` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `OpenaiThread` mutation. */
export type DeleteOpenaiThreadPayload = {
  __typename?: 'DeleteOpenaiThreadPayload';
  /** Reads a single `Account` that is related to this `OpenaiThread`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `OpenaiThread`. */
  consumer?: Maybe<Consumer>;
  deletedOpenaiThreadId?: Maybe<Scalars['ID']>;
  /** The `OpenaiThread` that was deleted by this mutation. */
  openaiThread?: Maybe<OpenaiThread>;
  /** An edge for our `OpenaiThread`. May be used by Relay 1. */
  openaiThreadEdge?: Maybe<OpenaiThreadsEdge>;
  /** Reads a single `Provider` that is related to this `OpenaiThread`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OpenaiThread` mutation. */
export type DeleteOpenaiThreadPayloadOpenaiThreadEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};

/** All input for the `deleteProviderTransactionById` mutation. */
export type DeleteProviderTransactionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate` mutation. */
export type DeleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput = {
  address1: Scalars['String'];
  city: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  closeDate: Scalars['Date'];
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};

/** All input for the `deleteProviderTransaction` mutation. */
export type DeleteProviderTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProviderTransaction` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `ProviderTransaction` mutation. */
export type DeleteProviderTransactionPayload = {
  __typename?: 'DeleteProviderTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProviderTransactionId?: Maybe<Scalars['ID']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  /** The `ProviderTransaction` that was deleted by this mutation. */
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProviderTransaction` mutation. */
export type DeleteProviderTransactionPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** All input for the `deleteReviewById` mutation. */
export type DeleteReviewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `deleteReviewById` mutation. */
export type DeleteReviewByIdPayload = {
  __typename?: 'DeleteReviewByIdPayload';
  /** Reads a single `Account` that is related to this `Provider`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Media` that is related to this `Provider`. */
  image?: Maybe<Media>;
  provider?: Maybe<Provider>;
  /** An edge for our `Provider`. May be used by Relay 1. */
  providerEdge?: Maybe<ProvidersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteReviewById` mutation. */
export type DeleteReviewByIdPayloadProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};

export type DocusignEnvelope = Node & {
  __typename?: 'DocusignEnvelope';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `DocusignEnvelopeRecipient`. */
  docusignEnvelopeRecipients: DocusignEnvelopeRecipientsConnection;
  envelopeId?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipients?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  template: Scalars['String'];
};


export type DocusignEnvelopeDocusignEnvelopeRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocusignEnvelopeRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocusignEnvelopeRecipientsOrderBy>>;
};

export type DocusignEnvelopeRecipient = Node & {
  __typename?: 'DocusignEnvelopeRecipient';
  /** Reads a single `Account` that is related to this `DocusignEnvelopeRecipient`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** Reads a single `DocusignEnvelope` that is related to this `DocusignEnvelopeRecipient`. */
  docusignEnvelope?: Maybe<DocusignEnvelope>;
  docusignEnvelopeId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipientId?: Maybe<Scalars['UUID']>;
  role: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DocusignEnvelopeRecipient` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocusignEnvelopeRecipientCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `docusignEnvelopeId` field. */
  docusignEnvelopeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `DocusignEnvelopeRecipient` values. */
export type DocusignEnvelopeRecipientsConnection = {
  __typename?: 'DocusignEnvelopeRecipientsConnection';
  /** A list of edges which contains the `DocusignEnvelopeRecipient` and cursor to aid in pagination. */
  edges: Array<DocusignEnvelopeRecipientsEdge>;
  /** A list of `DocusignEnvelopeRecipient` objects. */
  nodes: Array<DocusignEnvelopeRecipient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocusignEnvelopeRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocusignEnvelopeRecipient` edge in the connection. */
export type DocusignEnvelopeRecipientsEdge = {
  __typename?: 'DocusignEnvelopeRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocusignEnvelopeRecipient` at the end of the edge. */
  node: DocusignEnvelopeRecipient;
};

/** Methods to use when ordering `DocusignEnvelopeRecipient`. */
export enum DocusignEnvelopeRecipientsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  DocusignEnvelopeIdAsc = 'DOCUSIGN_ENVELOPE_ID_ASC',
  DocusignEnvelopeIdDesc = 'DOCUSIGN_ENVELOPE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientIdAsc = 'RECIPIENT_ID_ASC',
  RecipientIdDesc = 'RECIPIENT_ID_DESC'
}

export type ExternalLead = Node & {
  __typename?: 'ExternalLead';
  createdAt: Scalars['Datetime'];
  data: Scalars['JSON'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  raw: Scalars['JSON'];
  source: Scalars['String'];
};

/** An input for mutations affecting `ExternalLead` */
export type ExternalLeadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  data: Scalars['JSON'];
  id?: InputMaybe<Scalars['UUID']>;
  raw: Scalars['JSON'];
  source: Scalars['String'];
};

/** All input for the `generateVerification` mutation. */
export type GenerateVerificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['String'];
};

/** The output of our `generateVerification` mutation. */
export type GenerateVerificationPayload = {
  __typename?: 'GenerateVerificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `hire` mutation. */
export type HireInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `hire` mutation. */
export type HirePayload = {
  __typename?: 'HirePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Inquiry` values. */
export type InquiriesConnection = {
  __typename?: 'InquiriesConnection';
  /** A list of edges which contains the `Inquiry` and cursor to aid in pagination. */
  edges: Array<InquiriesEdge>;
  /** A list of `Inquiry` objects. */
  nodes: Array<Inquiry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Inquiry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Inquiry` edge in the connection. */
export type InquiriesEdge = {
  __typename?: 'InquiriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Inquiry` at the end of the edge. */
  node: Inquiry;
};

/** Methods to use when ordering `Inquiry`. */
export enum InquiriesOrderBy {
  ConsumerIdAsc = 'CONSUMER_ID_ASC',
  ConsumerIdDesc = 'CONSUMER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Inquiry = Node & {
  __typename?: 'Inquiry';
  /** Reads a single `Consumer` that is related to this `Inquiry`. */
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  detailsConfirmed?: Maybe<Scalars['Datetime']>;
  ebDeal?: Maybe<Scalars['JSON']>;
  ebDealUniqueId?: Maybe<Scalars['String']>;
  flags?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InquiryAddress`. */
  inquiryAddresses: InquiryAddressesConnection;
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection;
  matches?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  potentialProviders: PotentialProvidersConnection;
  providers?: Maybe<Scalars['JSON']>;
};


export type InquiryInquiryAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};


export type InquiryLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};


export type InquiryPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InquiryAddress = Node & {
  __typename?: 'InquiryAddress';
  address: Scalars['String'];
  ebDealUniqueId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  inquiryId: Scalars['UUID'];
  latitude: Scalars['BigFloat'];
  location: Scalars['String'];
  longitude: Scalars['BigFloat'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  price?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `InquiryAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InquiryAddressCondition = {
  /** Checks for equality with the object’s `ebDealUniqueId` field. */
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inquiryId` field. */
  inquiryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `InquiryAddress` */
export type InquiryAddressInput = {
  address: Scalars['String'];
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  inquiryId: Scalars['UUID'];
  latitude: Scalars['BigFloat'];
  location: Scalars['String'];
  longitude: Scalars['BigFloat'];
  price?: InputMaybe<Scalars['BigFloat']>;
};

/** Represents an update to a `InquiryAddress`. Fields that are set will be updated. */
export type InquiryAddressPatch = {
  address?: InputMaybe<Scalars['String']>;
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  location?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `InquiryAddress` values. */
export type InquiryAddressesConnection = {
  __typename?: 'InquiryAddressesConnection';
  /** A list of edges which contains the `InquiryAddress` and cursor to aid in pagination. */
  edges: Array<InquiryAddressesEdge>;
  /** A list of `InquiryAddress` objects. */
  nodes: Array<InquiryAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InquiryAddress` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InquiryAddress` edge in the connection. */
export type InquiryAddressesEdge = {
  __typename?: 'InquiryAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InquiryAddress` at the end of the edge. */
  node: InquiryAddress;
};

/** Methods to use when ordering `InquiryAddress`. */
export enum InquiryAddressesOrderBy {
  EbDealUniqueIdAsc = 'EB_DEAL_UNIQUE_ID_ASC',
  EbDealUniqueIdDesc = 'EB_DEAL_UNIQUE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InquiryIdAsc = 'INQUIRY_ID_ASC',
  InquiryIdDesc = 'INQUIRY_ID_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Inquiry` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type InquiryCondition = {
  /** Checks for equality with the object’s `consumerId` field. */
  consumerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Inquiry` */
export type InquiryInput = {
  details: Scalars['JSON'];
  detailsConfirmed?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Inquiry`. Fields that are set will be updated. */
export type InquiryPatch = {
  details?: InputMaybe<Scalars['JSON']>;
  detailsConfirmed?: InputMaybe<Scalars['Datetime']>;
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Scalars['JSON']>;
  providers?: InputMaybe<Scalars['JSON']>;
};

export type Invitation = Node & {
  __typename?: 'Invitation';
  /** Reads a single `Account` that is related to this `Invitation`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Invitation`. */
  accountByReferred?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  email: Scalars['Email'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  info?: Maybe<Scalars['JSON']>;
  lastName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  referred?: Maybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `Invitation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InvitationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referred` field. */
  referred?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Invitation` */
export type InvitationInput = {
  email: Scalars['Email'];
  firstName: Scalars['String'];
  info?: InputMaybe<Scalars['JSON']>;
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Invitation` values. */
export type InvitationsConnection = {
  __typename?: 'InvitationsConnection';
  /** A list of edges which contains the `Invitation` and cursor to aid in pagination. */
  edges: Array<InvitationsEdge>;
  /** A list of `Invitation` objects. */
  nodes: Array<Invitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Invitation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Invitation` edge in the connection. */
export type InvitationsEdge = {
  __typename?: 'InvitationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Invitation` at the end of the edge. */
  node: Invitation;
};

/** Methods to use when ordering `Invitation`. */
export enum InvitationsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferredAsc = 'REFERRED_ASC',
  ReferredDesc = 'REFERRED_DESC'
}

export type Lead = Node & {
  __typename?: 'Lead';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  ebDealUniqueId?: Maybe<Scalars['String']>;
  history: Scalars['JSON'];
  id: Scalars['UUID'];
  info: Scalars['JSON'];
  /** Reads a single `Inquiry` that is related to this `Lead`. */
  inquiry?: Maybe<Inquiry>;
  inquiryId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Provider` that is related to this `Lead`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  status: LeadStatus;
  transaction: Scalars['JSON'];
};

/** A condition to be used against `Lead` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LeadCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inquiryId` field. */
  inquiryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Lead` */
export type LeadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['JSON']>;
  inquiryId: Scalars['UUID'];
  providerId: Scalars['UUID'];
  status?: InputMaybe<LeadStatus>;
  transaction?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `Lead`. Fields that are set will be updated. */
export type LeadPatch = {
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  info?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<LeadStatus>;
  transaction?: InputMaybe<Scalars['JSON']>;
};

export enum LeadStatus {
  Closed = 'CLOSED',
  InEscrow = 'IN_ESCROW',
  Shopping = 'SHOPPING',
  WaitingToConnect = 'WAITING_TO_CONNECT'
}

/** A connection to a list of `Lead` values. */
export type LeadsConnection = {
  __typename?: 'LeadsConnection';
  /** A list of edges which contains the `Lead` and cursor to aid in pagination. */
  edges: Array<LeadsEdge>;
  /** A list of `Lead` objects. */
  nodes: Array<Lead>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Lead` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Lead` edge in the connection. */
export type LeadsEdge = {
  __typename?: 'LeadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Lead` at the end of the edge. */
  node: Lead;
};

/** Methods to use when ordering `Lead`. */
export enum LeadsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InquiryIdAsc = 'INQUIRY_ID_ASC',
  InquiryIdDesc = 'INQUIRY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

export type License = Node & {
  __typename?: 'License';
  areaCenter?: Maybe<Scalars['JSON']>;
  bio?: Maybe<Scalars['String']>;
  brokerEmail?: Maybe<Scalars['String']>;
  brokerLicenseNumber?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  brokerPhone?: Maybe<Scalars['String']>;
  brokerageAddress?: Maybe<Scalars['String']>;
  brokerageName?: Maybe<Scalars['String']>;
  brokerageState?: Maybe<Scalars['String']>;
  brokerageTimeZone?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['JSON']>;
  contacts: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  geoJson?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  licenseExpiration?: Maybe<Scalars['Date']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mls: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  primaryPhone?: Maybe<Scalars['String']>;
  professionalCategory?: Maybe<LicenseCategory>;
  /** Reads a single `Provider` that is related to this `License`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  secondaryPhone?: Maybe<Scalars['String']>;
  serviceAreaUpdated?: Maybe<Scalars['Datetime']>;
  transactionHistory: Scalars['JSON'];
  urls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum LicenseCategory {
  Attorney = 'ATTORNEY',
  MortgageAgent = 'MORTGAGE_AGENT',
  MortgageBroker = 'MORTGAGE_BROKER',
  OtherRealEstateProfessional = 'OTHER_REAL_ESTATE_PROFESSIONAL',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  RealEstateBroker = 'REAL_ESTATE_BROKER',
  TitleAgent = 'TITLE_AGENT'
}

/** A condition to be used against `License` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LicenseCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `License` */
export type LicenseInput = {
  bio?: InputMaybe<Scalars['String']>;
  brokerEmail?: InputMaybe<Scalars['String']>;
  brokerLicenseNumber?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  brokerPhone?: InputMaybe<Scalars['String']>;
  brokerageAddress?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  brokerageState?: InputMaybe<Scalars['String']>;
  brokerageTimeZone?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  licenseExpiration?: InputMaybe<Scalars['Date']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<Scalars['JSON']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  professionalCategory?: InputMaybe<LicenseCategory>;
  providerId: Scalars['UUID'];
  secondaryPhone?: InputMaybe<Scalars['String']>;
  serviceAreaUpdated?: InputMaybe<Scalars['Datetime']>;
  transactionHistory?: InputMaybe<Scalars['JSON']>;
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Represents an update to a `License`. Fields that are set will be updated. */
export type LicensePatch = {
  bio?: InputMaybe<Scalars['String']>;
  brokerEmail?: InputMaybe<Scalars['String']>;
  brokerLicenseNumber?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  brokerPhone?: InputMaybe<Scalars['String']>;
  brokerageAddress?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  brokerageState?: InputMaybe<Scalars['String']>;
  brokerageTimeZone?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  licenseExpiration?: InputMaybe<Scalars['Date']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<Scalars['JSON']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  professionalCategory?: InputMaybe<LicenseCategory>;
  providerId?: InputMaybe<Scalars['UUID']>;
  secondaryPhone?: InputMaybe<Scalars['String']>;
  serviceAreaUpdated?: InputMaybe<Scalars['Datetime']>;
  transactionHistory?: InputMaybe<Scalars['JSON']>;
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A connection to a list of `License` values. */
export type LicensesConnection = {
  __typename?: 'LicensesConnection';
  /** A list of edges which contains the `License` and cursor to aid in pagination. */
  edges: Array<LicensesEdge>;
  /** A list of `License` objects. */
  nodes: Array<License>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `License` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `License` edge in the connection. */
export type LicensesEdge = {
  __typename?: 'LicensesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `License` at the end of the edge. */
  node: License;
};

/** Methods to use when ordering `License`. */
export enum LicensesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

export type Link = Node & {
  __typename?: 'Link';
  data?: Maybe<Scalars['JSON']>;
  expiresAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
};

/** A `Link` edge in the connection. */
export type LinksEdge = {
  __typename?: 'LinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Link` at the end of the edge. */
  node: Link;
};

/** Methods to use when ordering `Link`. */
export enum LinksOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ListenPayload = {
  __typename?: 'ListenPayload';
  /** Our root query field type. Allows us to run any query from our subscription payload. */
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']>;
};

export type Log = Node & {
  __typename?: 'Log';
  /** Reads a single `Account` that is related to this `Log`. */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  data: Scalars['JSON'];
  level: LogLevel;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type: Scalars['String'];
};

/** A condition to be used against `Log` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LogCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `Log` */
export type LogInput = {
  data: Scalars['JSON'];
  level: LogLevel;
  type: Scalars['String'];
};

export enum LogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Verbose = 'VERBOSE',
  Warn = 'WARN'
}

/** All input for the `loginAs` mutation. */
export type LoginAsInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `loginAs` mutation. */
export type LoginAsPayload = {
  __typename?: 'LoginAsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
  /** An edge for our `Link`. May be used by Relay 1. */
  linkEdge?: Maybe<LinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `loginAs` mutation. */
export type LoginAsPayloadLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};

/** All input for the `login` mutation. */
export type LoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

/** The output of our `login` mutation. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `loginUsingSmsToken` mutation. */
export type LoginUsingSmsTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  token: Scalars['String'];
};

/** The output of our `loginUsingSmsToken` mutation. */
export type LoginUsingSmsTokenPayload = {
  __typename?: 'LoginUsingSmsTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Log` values. */
export type LogsConnection = {
  __typename?: 'LogsConnection';
  /** A list of edges which contains the `Log` and cursor to aid in pagination. */
  edges: Array<LogsEdge>;
  /** A list of `Log` objects. */
  nodes: Array<Log>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Log` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Log` edge in the connection. */
export type LogsEdge = {
  __typename?: 'LogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Log` at the end of the edge. */
  node: Log;
};

/** Methods to use when ordering `Log`. */
export enum LogsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type Media = Node & {
  __typename?: 'Media';
  /** Reads a single `Account` that is related to this `Media`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Media`. */
  accountByAvatarId?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  derivedFrom?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  meta?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Media` that is related to this `Media`. */
  parent?: Maybe<Media>;
  /** Reads and enables pagination through a set of `Media`. */
  sizes: MediaConnection;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uploadedAt?: Maybe<Scalars['Datetime']>;
  url?: Maybe<Scalars['String']>;
};


export type MediaSizesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

/** A condition to be used against `Media` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MediaCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `derivedFrom` field. */
  derivedFrom?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Media` values. */
export type MediaConnection = {
  __typename?: 'MediaConnection';
  /** A list of edges which contains the `Media` and cursor to aid in pagination. */
  edges: Array<MediaEdge>;
  /** A list of `Media` objects. */
  nodes: Array<Media>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Media` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Media` edge in the connection. */
export type MediaEdge = {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Media` at the end of the edge. */
  node: Media;
};

/** Methods to use when ordering `Media`. */
export enum MediaOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  DerivedFromAsc = 'DERIVED_FROM_ASC',
  DerivedFromDesc = 'DERIVED_FROM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Message = Node & {
  __typename?: 'Message';
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Account` that is related to this `Message`. */
  from?: Maybe<Account>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  openedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Account` that is related to this `Message`. */
  to?: Maybe<Account>;
  toId: Scalars['UUID'];
};

/** A condition to be used against `Message` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MessageCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `toId` field. */
  toId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Message` values. */
export type MessagesConnection = {
  __typename?: 'MessagesConnection';
  /** A list of edges which contains the `Message` and cursor to aid in pagination. */
  edges: Array<MessagesEdge>;
  /** A list of `Message` objects. */
  nodes: Array<Message>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Message` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Message` edge in the connection. */
export type MessagesEdge = {
  __typename?: 'MessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Message` at the end of the edge. */
  node: Message;
};

/** Methods to use when ordering `Message`. */
export enum MessagesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ToIdAsc = 'TO_ID_ASC',
  ToIdDesc = 'TO_ID_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  addDealAddress?: Maybe<AddDealAddressPayload>;
  addInquiryAddress?: Maybe<AddInquiryAddressPayload>;
  adminUpdateAccount?: Maybe<AdminUpdateAccountPayload>;
  contactUs?: Maybe<ContactUsPayload>;
  createAccountReferralCode?: Maybe<CreateAccountReferralCodePayload>;
  /** Creates a single `Alert`. */
  createAlert?: Maybe<CreateAlertPayload>;
  /** Creates a single `Contact`. */
  createContact?: Maybe<CreateContactPayload>;
  /** Creates a single `ExternalLead`. */
  createExternalLead?: Maybe<CreateExternalLeadPayload>;
  /** Creates a single `Inquiry`. */
  createInquiry?: Maybe<CreateInquiryPayload>;
  /** Creates a single `InquiryAddress`. */
  createInquiryAddress?: Maybe<CreateInquiryAddressPayload>;
  /** Creates a single `Invitation`. */
  createInvitation?: Maybe<CreateInvitationPayload>;
  /** Creates a single `Lead`. */
  createLead?: Maybe<CreateLeadPayload>;
  /** Creates a single `License`. */
  createLicense?: Maybe<CreateLicensePayload>;
  /** Creates a single `Log`. */
  createLog?: Maybe<CreateLogPayload>;
  /** Creates a single `Note`. */
  createNote?: Maybe<CreateNotePayload>;
  /** Creates a single `OpenaiAssistant`. */
  createOpenaiAssistant?: Maybe<CreateOpenaiAssistantPayload>;
  /** Creates a single `OpenaiMessage`. */
  createOpenaiMessage?: Maybe<CreateOpenaiMessagePayload>;
  /** Creates a single `OpenaiRun`. */
  createOpenaiRun?: Maybe<CreateOpenaiRunPayload>;
  /** Creates a single `OpenaiRunStep`. */
  createOpenaiRunStep?: Maybe<CreateOpenaiRunStepPayload>;
  /** Creates a single `OpenaiThread`. */
  createOpenaiThread?: Maybe<CreateOpenaiThreadPayload>;
  /** Creates a single `Payment`. */
  createPayment?: Maybe<CreatePaymentPayload>;
  /** Creates a single `PointsLedger`. */
  createPointsLedger?: Maybe<CreatePointsLedgerPayload>;
  /** Creates a single `PromoCode`. */
  createPromoCode?: Maybe<CreatePromoCodePayload>;
  /** Creates a single `ProviderTransaction`. */
  createProviderTransaction?: Maybe<CreateProviderTransactionPayload>;
  /** Creates a single `Redirect`. */
  createRedirect?: Maybe<CreateRedirectPayload>;
  createReferralCode?: Maybe<CreateReferralCodePayload>;
  /** Creates a single `Review`. */
  createReview?: Maybe<CreateReviewPayload>;
  /** Creates a single `UserActivity`. */
  createUserActivity?: Maybe<CreateUserActivityPayload>;
  /** Delete a single alert */
  deleteAlert?: Maybe<DeleteAlertPayload>;
  /** Delete a single Contact */
  deleteContact?: Maybe<DeleteContactPayload>;
  deleteDealAddress?: Maybe<DeleteDealAddressPayload>;
  /** Deletes a single `InquiryAddress` using its globally unique id. */
  deleteInquiryAddress?: Maybe<DeleteInquiryAddressPayload>;
  /** Deletes a single `InquiryAddress` using a unique key. */
  deleteInquiryAddressById?: Maybe<DeleteInquiryAddressPayload>;
  /** Delete a single Media */
  deleteMedia?: Maybe<DeleteMediaPayload>;
  /** Delete a single Note */
  deleteNote?: Maybe<DeleteNotePayload>;
  /** Deletes a single `OpenaiAssistant` using its globally unique id. */
  deleteOpenaiAssistant?: Maybe<DeleteOpenaiAssistantPayload>;
  /** Deletes a single `OpenaiAssistant` using a unique key. */
  deleteOpenaiAssistantById?: Maybe<DeleteOpenaiAssistantPayload>;
  /** Deletes a single `OpenaiMessage` using its globally unique id. */
  deleteOpenaiMessage?: Maybe<DeleteOpenaiMessagePayload>;
  /** Deletes a single `OpenaiMessage` using a unique key. */
  deleteOpenaiMessageById?: Maybe<DeleteOpenaiMessagePayload>;
  /** Deletes a single `OpenaiRun` using its globally unique id. */
  deleteOpenaiRun?: Maybe<DeleteOpenaiRunPayload>;
  /** Deletes a single `OpenaiRun` using a unique key. */
  deleteOpenaiRunById?: Maybe<DeleteOpenaiRunPayload>;
  /** Deletes a single `OpenaiRunStep` using its globally unique id. */
  deleteOpenaiRunStep?: Maybe<DeleteOpenaiRunStepPayload>;
  /** Deletes a single `OpenaiRunStep` using a unique key. */
  deleteOpenaiRunStepById?: Maybe<DeleteOpenaiRunStepPayload>;
  /** Deletes a single `OpenaiThread` using its globally unique id. */
  deleteOpenaiThread?: Maybe<DeleteOpenaiThreadPayload>;
  /** Deletes a single `OpenaiThread` using a unique key. */
  deleteOpenaiThreadById?: Maybe<DeleteOpenaiThreadPayload>;
  /** Deletes a single `ProviderTransaction` using its globally unique id. */
  deleteProviderTransaction?: Maybe<DeleteProviderTransactionPayload>;
  /** Deletes a single `ProviderTransaction` using a unique key. */
  deleteProviderTransactionById?: Maybe<DeleteProviderTransactionPayload>;
  /** Deletes a single `ProviderTransaction` using a unique key. */
  deleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<DeleteProviderTransactionPayload>;
  deleteReviewById?: Maybe<DeleteReviewByIdPayload>;
  generateVerification?: Maybe<GenerateVerificationPayload>;
  /** Hire a provider. */
  hire?: Maybe<HirePayload>;
  /** Login to account */
  login?: Maybe<LoginPayload>;
  loginAs?: Maybe<LoginAsPayload>;
  loginUsingSmsToken?: Maybe<LoginUsingSmsTokenPayload>;
  pointsLedgerAdjust?: Maybe<PointsLedgerAdjustPayload>;
  pointsLedgerIssue?: Maybe<PointsLedgerIssuePayload>;
  pointsLedgerRedeem?: Maybe<PointsLedgerRedeemPayload>;
  pointsLedgerRefund?: Maybe<PointsLedgerRefundPayload>;
  /** Refresh JWT */
  refreshJwt?: Maybe<RefreshJwtPayload>;
  /** Create a new consumer. */
  registerConsumer?: Maybe<RegisterConsumerPayload>;
  /** Create a new alternative consumer. */
  registerConsumerAlt?: Maybe<RegisterConsumerAltPayload>;
  /** Create a new real estate agent. */
  registerRealEstateAgent?: Maybe<RegisterRealEstateAgentPayload>;
  removeAccount?: Maybe<RemoveAccountPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  restoreAccount?: Maybe<RestoreAccountPayload>;
  /** Send phone number verification code via SMS. */
  sendPhoneVerify?: Maybe<SendPhoneVerifyPayload>;
  sendSmsLoginToken?: Maybe<SendSmsLoginTokenPayload>;
  /** Send verification code to contact. */
  sendVerificationCode?: Maybe<SendVerificationCodePayload>;
  /** Set password */
  setPassword?: Maybe<SetPasswordPayload>;
  /** Login to account using token */
  tokenLogin?: Maybe<TokenLoginPayload>;
  /** Updates a single `Account` using its globally unique id and a patch. */
  updateAccount?: Maybe<UpdateAccountPayload>;
  /** Updates a single `Account` using a unique key and a patch. */
  updateAccountByAvatarId?: Maybe<UpdateAccountPayload>;
  /** Updates a single `Account` using a unique key and a patch. */
  updateAccountById?: Maybe<UpdateAccountPayload>;
  /** Updates a single `Alert` using its globally unique id and a patch. */
  updateAlert?: Maybe<UpdateAlertPayload>;
  /** Updates a single `Alert` using a unique key and a patch. */
  updateAlertById?: Maybe<UpdateAlertPayload>;
  /** Updates a single `Consumer` using its globally unique id and a patch. */
  updateConsumer?: Maybe<UpdateConsumerPayload>;
  /** Updates a single `Consumer` using a unique key and a patch. */
  updateConsumerByAccountId?: Maybe<UpdateConsumerPayload>;
  /** Updates a single `Consumer` using a unique key and a patch. */
  updateConsumerById?: Maybe<UpdateConsumerPayload>;
  updateDealAddressPrice?: Maybe<UpdateDealAddressPricePayload>;
  updateGeoJson?: Maybe<UpdateGeoJsonPayload>;
  /** Updates a single `Inquiry` using its globally unique id and a patch. */
  updateInquiry?: Maybe<UpdateInquiryPayload>;
  /** Updates a single `InquiryAddress` using its globally unique id and a patch. */
  updateInquiryAddress?: Maybe<UpdateInquiryAddressPayload>;
  /** Updates a single `InquiryAddress` using a unique key and a patch. */
  updateInquiryAddressById?: Maybe<UpdateInquiryAddressPayload>;
  /** Updates a single `Inquiry` using a unique key and a patch. */
  updateInquiryById?: Maybe<UpdateInquiryPayload>;
  /** Updates a single `Lead` using its globally unique id and a patch. */
  updateLead?: Maybe<UpdateLeadPayload>;
  /** Updates a single `Lead` using a unique key and a patch. */
  updateLeadById?: Maybe<UpdateLeadPayload>;
  /** Updates a single `License` using its globally unique id and a patch. */
  updateLicense?: Maybe<UpdateLicensePayload>;
  /** Updates a single `License` using a unique key and a patch. */
  updateLicenseById?: Maybe<UpdateLicensePayload>;
  updateLicenseGeoJson?: Maybe<UpdateLicenseGeoJsonPayload>;
  /** Updates a single `Note` using its globally unique id and a patch. */
  updateNote?: Maybe<UpdateNotePayload>;
  /** Updates a single `Note` using a unique key and a patch. */
  updateNoteById?: Maybe<UpdateNotePayload>;
  /** Updates a single `OpenaiAssistant` using its globally unique id and a patch. */
  updateOpenaiAssistant?: Maybe<UpdateOpenaiAssistantPayload>;
  /** Updates a single `OpenaiAssistant` using a unique key and a patch. */
  updateOpenaiAssistantById?: Maybe<UpdateOpenaiAssistantPayload>;
  /** Updates a single `OpenaiMessage` using its globally unique id and a patch. */
  updateOpenaiMessage?: Maybe<UpdateOpenaiMessagePayload>;
  /** Updates a single `OpenaiMessage` using a unique key and a patch. */
  updateOpenaiMessageById?: Maybe<UpdateOpenaiMessagePayload>;
  /** Updates a single `OpenaiRun` using its globally unique id and a patch. */
  updateOpenaiRun?: Maybe<UpdateOpenaiRunPayload>;
  /** Updates a single `OpenaiRun` using a unique key and a patch. */
  updateOpenaiRunById?: Maybe<UpdateOpenaiRunPayload>;
  /** Updates a single `OpenaiRunStep` using its globally unique id and a patch. */
  updateOpenaiRunStep?: Maybe<UpdateOpenaiRunStepPayload>;
  /** Updates a single `OpenaiRunStep` using a unique key and a patch. */
  updateOpenaiRunStepById?: Maybe<UpdateOpenaiRunStepPayload>;
  /** Updates a single `OpenaiThread` using its globally unique id and a patch. */
  updateOpenaiThread?: Maybe<UpdateOpenaiThreadPayload>;
  /** Updates a single `OpenaiThread` using a unique key and a patch. */
  updateOpenaiThreadById?: Maybe<UpdateOpenaiThreadPayload>;
  /** Updates a single `Provider` using its globally unique id and a patch. */
  updateProvider?: Maybe<UpdateProviderPayload>;
  /** Updates a single `Provider` using a unique key and a patch. */
  updateProviderByAccountId?: Maybe<UpdateProviderPayload>;
  /** Updates a single `Provider` using a unique key and a patch. */
  updateProviderById?: Maybe<UpdateProviderPayload>;
  /** Updates a single `Provider` using a unique key and a patch. */
  updateProviderBySlug?: Maybe<UpdateProviderPayload>;
  /** Updates a single `ProviderTransaction` using its globally unique id and a patch. */
  updateProviderTransaction?: Maybe<UpdateProviderTransactionPayload>;
  /** Updates a single `ProviderTransaction` using a unique key and a patch. */
  updateProviderTransactionById?: Maybe<UpdateProviderTransactionPayload>;
  /** Updates a single `ProviderTransaction` using a unique key and a patch. */
  updateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<UpdateProviderTransactionPayload>;
  /** Updates a single `Review` using its globally unique id and a patch. */
  updateReview?: Maybe<UpdateReviewPayload>;
  /** Updates a single `Review` using a unique key and a patch. */
  updateReviewById?: Maybe<UpdateReviewPayload>;
  updateTransactionLocation?: Maybe<UpdateTransactionLocationPayload>;
  updateTransactionLocationLookupFailed?: Maybe<UpdateTransactionLocationLookupFailedPayload>;
  verify?: Maybe<VerifyPayload>;
  /** Verify method to contact user. */
  verifyContact?: Maybe<VerifyContactPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddDealAddressArgs = {
  input: AddDealAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddInquiryAddressArgs = {
  input: AddInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateAccountArgs = {
  input: AdminUpdateAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationContactUsArgs = {
  input: ContactUsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountReferralCodeArgs = {
  input: CreateAccountReferralCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalLeadArgs = {
  input: CreateExternalLeadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInquiryArgs = {
  input: CreateInquiryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInquiryAddressArgs = {
  input: CreateInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLogArgs = {
  input: CreateLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenaiAssistantArgs = {
  input: CreateOpenaiAssistantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenaiMessageArgs = {
  input: CreateOpenaiMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenaiRunArgs = {
  input: CreateOpenaiRunInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenaiRunStepArgs = {
  input: CreateOpenaiRunStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenaiThreadArgs = {
  input: CreateOpenaiThreadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePointsLedgerArgs = {
  input: CreatePointsLedgerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePromoCodeArgs = {
  input: CreatePromoCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProviderTransactionArgs = {
  input: CreateProviderTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRedirectArgs = {
  input: CreateRedirectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReferralCodeArgs = {
  input: CreateReferralCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserActivityArgs = {
  input: CreateUserActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAlertArgs = {
  input: DeleteAlertInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDealAddressArgs = {
  input: DeleteDealAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInquiryAddressArgs = {
  input: DeleteInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInquiryAddressByIdArgs = {
  input: DeleteInquiryAddressByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaArgs = {
  input: DeleteMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiAssistantArgs = {
  input: DeleteOpenaiAssistantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiAssistantByIdArgs = {
  input: DeleteOpenaiAssistantByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiMessageArgs = {
  input: DeleteOpenaiMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiMessageByIdArgs = {
  input: DeleteOpenaiMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiRunArgs = {
  input: DeleteOpenaiRunInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiRunByIdArgs = {
  input: DeleteOpenaiRunByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiRunStepArgs = {
  input: DeleteOpenaiRunStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiRunStepByIdArgs = {
  input: DeleteOpenaiRunStepByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiThreadArgs = {
  input: DeleteOpenaiThreadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenaiThreadByIdArgs = {
  input: DeleteOpenaiThreadByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProviderTransactionArgs = {
  input: DeleteProviderTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProviderTransactionByIdArgs = {
  input: DeleteProviderTransactionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  input: DeleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReviewByIdArgs = {
  input: DeleteReviewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateVerificationArgs = {
  input: GenerateVerificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationHireArgs = {
  input: HireInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginArgs = {
  input: LoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginAsArgs = {
  input: LoginAsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginUsingSmsTokenArgs = {
  input: LoginUsingSmsTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPointsLedgerAdjustArgs = {
  input: PointsLedgerAdjustInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPointsLedgerIssueArgs = {
  input: PointsLedgerIssueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPointsLedgerRedeemArgs = {
  input: PointsLedgerRedeemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPointsLedgerRefundArgs = {
  input: PointsLedgerRefundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRefreshJwtArgs = {
  input: RefreshJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterConsumerArgs = {
  input: RegisterConsumerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterConsumerAltArgs = {
  input: RegisterConsumerAltInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterRealEstateAgentArgs = {
  input: RegisterRealEstateAgentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRestoreAccountArgs = {
  input: RestoreAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendPhoneVerifyArgs = {
  input: SendPhoneVerifyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendSmsLoginTokenArgs = {
  input: SendSmsLoginTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendVerificationCodeArgs = {
  input: SendVerificationCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetPasswordArgs = {
  input: SetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTokenLoginArgs = {
  input: TokenLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountByAvatarIdArgs = {
  input: UpdateAccountByAvatarIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountByIdArgs = {
  input: UpdateAccountByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAlertArgs = {
  input: UpdateAlertInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAlertByIdArgs = {
  input: UpdateAlertByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConsumerArgs = {
  input: UpdateConsumerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConsumerByAccountIdArgs = {
  input: UpdateConsumerByAccountIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConsumerByIdArgs = {
  input: UpdateConsumerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDealAddressPriceArgs = {
  input: UpdateDealAddressPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeoJsonArgs = {
  input: UpdateGeoJsonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryArgs = {
  input: UpdateInquiryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryAddressArgs = {
  input: UpdateInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryAddressByIdArgs = {
  input: UpdateInquiryAddressByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryByIdArgs = {
  input: UpdateInquiryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadByIdArgs = {
  input: UpdateLeadByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLicenseByIdArgs = {
  input: UpdateLicenseByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLicenseGeoJsonArgs = {
  input: UpdateLicenseGeoJsonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNoteByIdArgs = {
  input: UpdateNoteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiAssistantArgs = {
  input: UpdateOpenaiAssistantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiAssistantByIdArgs = {
  input: UpdateOpenaiAssistantByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiMessageArgs = {
  input: UpdateOpenaiMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiMessageByIdArgs = {
  input: UpdateOpenaiMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiRunArgs = {
  input: UpdateOpenaiRunInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiRunByIdArgs = {
  input: UpdateOpenaiRunByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiRunStepArgs = {
  input: UpdateOpenaiRunStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiRunStepByIdArgs = {
  input: UpdateOpenaiRunStepByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiThreadArgs = {
  input: UpdateOpenaiThreadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenaiThreadByIdArgs = {
  input: UpdateOpenaiThreadByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderArgs = {
  input: UpdateProviderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderByAccountIdArgs = {
  input: UpdateProviderByAccountIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderByIdArgs = {
  input: UpdateProviderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderBySlugArgs = {
  input: UpdateProviderBySlugInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderTransactionArgs = {
  input: UpdateProviderTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderTransactionByIdArgs = {
  input: UpdateProviderTransactionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  input: UpdateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReviewArgs = {
  input: UpdateReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReviewByIdArgs = {
  input: UpdateReviewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTransactionLocationArgs = {
  input: UpdateTransactionLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTransactionLocationLookupFailedArgs = {
  input: UpdateTransactionLocationLookupFailedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyArgs = {
  input: VerifyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyContactArgs = {
  input: VerifyContactInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export type Note = Node & {
  __typename?: 'Note';
  /** Reads a single `Account` that is related to this `Note`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Scalars['String'];
  topic: Scalars['String'];
  topicId: Scalars['String'];
  type: NoteType;
};

/** A condition to be used against `Note` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type NoteCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `topic` field. */
  topic?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `topicId` field. */
  topicId?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `Note` */
export type NoteInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note: Scalars['String'];
  topic: Scalars['String'];
  topicId: Scalars['String'];
  type?: InputMaybe<NoteType>;
};

/** Represents an update to a `Note`. Fields that are set will be updated. */
export type NotePatch = {
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NoteType>;
};

export enum NoteType {
  Alert = 'ALERT',
  Info = 'INFO'
}

/** A connection to a list of `Note` values. */
export type NotesConnection = {
  __typename?: 'NotesConnection';
  /** A list of edges which contains the `Note` and cursor to aid in pagination. */
  edges: Array<NotesEdge>;
  /** A list of `Note` objects. */
  nodes: Array<Note>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Note` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Note` edge in the connection. */
export type NotesEdge = {
  __typename?: 'NotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Note` at the end of the edge. */
  node: Note;
};

/** Methods to use when ordering `Note`. */
export enum NotesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TopicAsc = 'TOPIC_ASC',
  TopicDesc = 'TOPIC_DESC',
  TopicIdAsc = 'TOPIC_ID_ASC',
  TopicIdDesc = 'TOPIC_ID_DESC'
}

export type OpenaiAssistant = Node & {
  __typename?: 'OpenaiAssistant';
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  fileIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  model: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OpenaiMessage`. */
  openaiMessagesByAssistantId: OpenaiMessagesConnection;
  /** Reads and enables pagination through a set of `OpenaiRunStep`. */
  openaiRunStepsByAssistantId: OpenaiRunStepsConnection;
  /** Reads and enables pagination through a set of `OpenaiRun`. */
  openaiRunsByAssistantId: OpenaiRunsConnection;
  tools?: Maybe<Scalars['JSON']>;
};


export type OpenaiAssistantOpenaiMessagesByAssistantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};


export type OpenaiAssistantOpenaiRunStepsByAssistantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunStepCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};


export type OpenaiAssistantOpenaiRunsByAssistantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};

/**
 * A condition to be used against `OpenaiAssistant` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OpenaiAssistantCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `OpenaiAssistant` */
export type OpenaiAssistantInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['String'];
  instructions?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  model: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  tools?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `OpenaiAssistant`. Fields that are set will be updated. */
export type OpenaiAssistantPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tools?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `OpenaiAssistant` values. */
export type OpenaiAssistantsConnection = {
  __typename?: 'OpenaiAssistantsConnection';
  /** A list of edges which contains the `OpenaiAssistant` and cursor to aid in pagination. */
  edges: Array<OpenaiAssistantsEdge>;
  /** A list of `OpenaiAssistant` objects. */
  nodes: Array<OpenaiAssistant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenaiAssistant` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpenaiAssistant` edge in the connection. */
export type OpenaiAssistantsEdge = {
  __typename?: 'OpenaiAssistantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpenaiAssistant` at the end of the edge. */
  node: OpenaiAssistant;
};

/** Methods to use when ordering `OpenaiAssistant`. */
export enum OpenaiAssistantsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type OpenaiMessage = Node & {
  __typename?: 'OpenaiMessage';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiMessage`. */
  assistant?: Maybe<OpenaiAssistant>;
  assistantId?: Maybe<Scalars['String']>;
  content: Scalars['JSON'];
  createdAt?: Maybe<Scalars['Datetime']>;
  fileIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  role: Scalars['String'];
  /** Reads a single `OpenaiRun` that is related to this `OpenaiMessage`. */
  run?: Maybe<OpenaiRun>;
  runId?: Maybe<Scalars['String']>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiMessage`. */
  thread?: Maybe<OpenaiThread>;
  threadId: Scalars['String'];
};

/**
 * A condition to be used against `OpenaiMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OpenaiMessageCondition = {
  /** Checks for equality with the object’s `assistantId` field. */
  assistantId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `runId` field. */
  runId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `threadId` field. */
  threadId?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `OpenaiMessage` */
export type OpenaiMessageInput = {
  assistantId?: InputMaybe<Scalars['String']>;
  content: Scalars['JSON'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  role: Scalars['String'];
  runId?: InputMaybe<Scalars['String']>;
  threadId: Scalars['String'];
};

/** Represents an update to a `OpenaiMessage`. Fields that are set will be updated. */
export type OpenaiMessagePatch = {
  assistantId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  role?: InputMaybe<Scalars['String']>;
  runId?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `OpenaiMessage` values. */
export type OpenaiMessagesConnection = {
  __typename?: 'OpenaiMessagesConnection';
  /** A list of edges which contains the `OpenaiMessage` and cursor to aid in pagination. */
  edges: Array<OpenaiMessagesEdge>;
  /** A list of `OpenaiMessage` objects. */
  nodes: Array<OpenaiMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenaiMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpenaiMessage` edge in the connection. */
export type OpenaiMessagesEdge = {
  __typename?: 'OpenaiMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpenaiMessage` at the end of the edge. */
  node: OpenaiMessage;
};

/** Methods to use when ordering `OpenaiMessage`. */
export enum OpenaiMessagesOrderBy {
  AssistantIdAsc = 'ASSISTANT_ID_ASC',
  AssistantIdDesc = 'ASSISTANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RunIdAsc = 'RUN_ID_ASC',
  RunIdDesc = 'RUN_ID_DESC',
  ThreadIdAsc = 'THREAD_ID_ASC',
  ThreadIdDesc = 'THREAD_ID_DESC'
}

export type OpenaiRun = Node & {
  __typename?: 'OpenaiRun';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRun`. */
  assistant?: Maybe<OpenaiAssistant>;
  assistantId: Scalars['String'];
  cancelledAt?: Maybe<Scalars['Datetime']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  expiresAt?: Maybe<Scalars['Datetime']>;
  failedAt?: Maybe<Scalars['Datetime']>;
  fileIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  lastError?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OpenaiMessage`. */
  openaiMessagesByRunId: OpenaiMessagesConnection;
  /** Reads and enables pagination through a set of `OpenaiRunStep`. */
  openaiRunStepsByRunId: OpenaiRunStepsConnection;
  startedAt?: Maybe<Scalars['Datetime']>;
  status: Scalars['String'];
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRun`. */
  thread?: Maybe<OpenaiThread>;
  threadId: Scalars['String'];
  tools?: Maybe<Scalars['JSON']>;
  usage?: Maybe<Scalars['JSON']>;
};


export type OpenaiRunOpenaiMessagesByRunIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};


export type OpenaiRunOpenaiRunStepsByRunIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunStepCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};

/**
 * A condition to be used against `OpenaiRun` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OpenaiRunCondition = {
  /** Checks for equality with the object’s `assistantId` field. */
  assistantId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `threadId` field. */
  threadId?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `OpenaiRun` */
export type OpenaiRunInput = {
  assistantId: Scalars['String'];
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  failedAt?: InputMaybe<Scalars['Datetime']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['String'];
  instructions?: InputMaybe<Scalars['String']>;
  lastError?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status: Scalars['String'];
  threadId: Scalars['String'];
  tools?: InputMaybe<Scalars['JSON']>;
  usage?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `OpenaiRun`. Fields that are set will be updated. */
export type OpenaiRunPatch = {
  assistantId?: InputMaybe<Scalars['String']>;
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  failedAt?: InputMaybe<Scalars['Datetime']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  lastError?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
  tools?: InputMaybe<Scalars['JSON']>;
  usage?: InputMaybe<Scalars['JSON']>;
};

export type OpenaiRunStep = Node & {
  __typename?: 'OpenaiRunStep';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRunStep`. */
  assistant?: Maybe<OpenaiAssistant>;
  assistantId: Scalars['String'];
  cancelledAt?: Maybe<Scalars['Datetime']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  expiredAt?: Maybe<Scalars['Datetime']>;
  failedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['String'];
  lastError?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `OpenaiRun` that is related to this `OpenaiRunStep`. */
  run?: Maybe<OpenaiRun>;
  runId: Scalars['String'];
  status: Scalars['String'];
  stepDetails?: Maybe<Scalars['JSON']>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRunStep`. */
  thread?: Maybe<OpenaiThread>;
  threadId: Scalars['String'];
  type: Scalars['String'];
  usage?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `OpenaiRunStep` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OpenaiRunStepCondition = {
  /** Checks for equality with the object’s `assistantId` field. */
  assistantId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `runId` field. */
  runId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `threadId` field. */
  threadId?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `OpenaiRunStep` */
export type OpenaiRunStepInput = {
  assistantId: Scalars['String'];
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  expiredAt?: InputMaybe<Scalars['Datetime']>;
  failedAt?: InputMaybe<Scalars['Datetime']>;
  id: Scalars['String'];
  lastError?: InputMaybe<Scalars['String']>;
  runId: Scalars['String'];
  status: Scalars['String'];
  stepDetails?: InputMaybe<Scalars['JSON']>;
  threadId: Scalars['String'];
  type: Scalars['String'];
  usage?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `OpenaiRunStep`. Fields that are set will be updated. */
export type OpenaiRunStepPatch = {
  assistantId?: InputMaybe<Scalars['String']>;
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  expiredAt?: InputMaybe<Scalars['Datetime']>;
  failedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['String']>;
  lastError?: InputMaybe<Scalars['String']>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stepDetails?: InputMaybe<Scalars['JSON']>;
  threadId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `OpenaiRunStep` values. */
export type OpenaiRunStepsConnection = {
  __typename?: 'OpenaiRunStepsConnection';
  /** A list of edges which contains the `OpenaiRunStep` and cursor to aid in pagination. */
  edges: Array<OpenaiRunStepsEdge>;
  /** A list of `OpenaiRunStep` objects. */
  nodes: Array<OpenaiRunStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenaiRunStep` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpenaiRunStep` edge in the connection. */
export type OpenaiRunStepsEdge = {
  __typename?: 'OpenaiRunStepsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpenaiRunStep` at the end of the edge. */
  node: OpenaiRunStep;
};

/** Methods to use when ordering `OpenaiRunStep`. */
export enum OpenaiRunStepsOrderBy {
  AssistantIdAsc = 'ASSISTANT_ID_ASC',
  AssistantIdDesc = 'ASSISTANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RunIdAsc = 'RUN_ID_ASC',
  RunIdDesc = 'RUN_ID_DESC',
  ThreadIdAsc = 'THREAD_ID_ASC',
  ThreadIdDesc = 'THREAD_ID_DESC'
}

/** A connection to a list of `OpenaiRun` values. */
export type OpenaiRunsConnection = {
  __typename?: 'OpenaiRunsConnection';
  /** A list of edges which contains the `OpenaiRun` and cursor to aid in pagination. */
  edges: Array<OpenaiRunsEdge>;
  /** A list of `OpenaiRun` objects. */
  nodes: Array<OpenaiRun>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenaiRun` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpenaiRun` edge in the connection. */
export type OpenaiRunsEdge = {
  __typename?: 'OpenaiRunsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpenaiRun` at the end of the edge. */
  node: OpenaiRun;
};

/** Methods to use when ordering `OpenaiRun`. */
export enum OpenaiRunsOrderBy {
  AssistantIdAsc = 'ASSISTANT_ID_ASC',
  AssistantIdDesc = 'ASSISTANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ThreadIdAsc = 'THREAD_ID_ASC',
  ThreadIdDesc = 'THREAD_ID_DESC'
}

export type OpenaiThread = Node & {
  __typename?: 'OpenaiThread';
  /** Reads a single `Account` that is related to this `OpenaiThread`. */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Consumer` that is related to this `OpenaiThread`. */
  consumer?: Maybe<Consumer>;
  consumerId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OpenaiMessage`. */
  openaiMessagesByThreadId: OpenaiMessagesConnection;
  /** Reads and enables pagination through a set of `OpenaiRunStep`. */
  openaiRunStepsByThreadId: OpenaiRunStepsConnection;
  /** Reads and enables pagination through a set of `OpenaiRun`. */
  openaiRunsByThreadId: OpenaiRunsConnection;
  /** Reads a single `Provider` that is related to this `OpenaiThread`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
};


export type OpenaiThreadOpenaiMessagesByThreadIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};


export type OpenaiThreadOpenaiRunStepsByThreadIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunStepCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};


export type OpenaiThreadOpenaiRunsByThreadIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};

/**
 * A condition to be used against `OpenaiThread` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OpenaiThreadCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `consumerId` field. */
  consumerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `OpenaiThread` */
export type OpenaiThreadInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  consumerId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `OpenaiThread`. Fields that are set will be updated. */
export type OpenaiThreadPatch = {
  accountId?: InputMaybe<Scalars['UUID']>;
  consumerId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `OpenaiThread` values. */
export type OpenaiThreadsConnection = {
  __typename?: 'OpenaiThreadsConnection';
  /** A list of edges which contains the `OpenaiThread` and cursor to aid in pagination. */
  edges: Array<OpenaiThreadsEdge>;
  /** A list of `OpenaiThread` objects. */
  nodes: Array<OpenaiThread>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenaiThread` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpenaiThread` edge in the connection. */
export type OpenaiThreadsEdge = {
  __typename?: 'OpenaiThreadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpenaiThread` at the end of the edge. */
  node: OpenaiThread;
};

/** Methods to use when ordering `OpenaiThread`. */
export enum OpenaiThreadsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  ConsumerIdAsc = 'CONSUMER_ID_ASC',
  ConsumerIdDesc = 'CONSUMER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Payment = Node & {
  __typename?: 'Payment';
  /** Reads a single `Account` that is related to this `Payment`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  amount?: Maybe<Scalars['BigFloat']>;
  approved?: Maybe<Scalars['Boolean']>;
  billingAddress?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  lastFour?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  processor?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
  type?: Maybe<PaymentType>;
};

/** A condition to be used against `Payment` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PaymentCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `approved` field. */
  approved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<PaymentType>;
};

/** An input for mutations affecting `Payment` */
export type PaymentInput = {
  accountId: Scalars['UUID'];
  amount?: InputMaybe<Scalars['BigFloat']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastFour?: InputMaybe<Scalars['String']>;
  processor?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<PaymentType>;
};

export enum PaymentType {
  Membership = 'MEMBERSHIP'
}

/** A connection to a list of `Payment` values. */
export type PaymentsConnection = {
  __typename?: 'PaymentsConnection';
  /** A list of edges which contains the `Payment` and cursor to aid in pagination. */
  edges: Array<PaymentsEdge>;
  /** A list of `Payment` objects. */
  nodes: Array<Payment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Payment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Payment` edge in the connection. */
export type PaymentsEdge = {
  __typename?: 'PaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Payment` at the end of the edge. */
  node: Payment;
};

/** Methods to use when ordering `Payment`. */
export enum PaymentsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  ApprovedAsc = 'APPROVED_ASC',
  ApprovedDesc = 'APPROVED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type PointsLedger = Node & {
  __typename?: 'PointsLedger';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['UUID']>;
  data?: Maybe<Scalars['JSON']>;
  entryType: PointsLedgerEntryType;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

/** All input for the `pointsLedgerAdjust` mutation. */
export type PointsLedgerAdjustInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  note: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The output of our `pointsLedgerAdjust` mutation. */
export type PointsLedgerAdjustPayload = {
  __typename?: 'PointsLedgerAdjustPayload';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  pointsLedger?: Maybe<PointsLedger>;
  /** An edge for our `PointsLedger`. May be used by Relay 1. */
  pointsLedgerEdge?: Maybe<PointsLedgersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `pointsLedgerAdjust` mutation. */
export type PointsLedgerAdjustPayloadPointsLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};

/**
 * A condition to be used against `PointsLedger` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PointsLedgerCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

export enum PointsLedgerEntryType {
  Adjust = 'ADJUST',
  Issue = 'ISSUE',
  Redeem = 'REDEEM',
  Refund = 'REFUND'
}

/** An input for mutations affecting `PointsLedger` */
export type PointsLedgerInput = {
  accountId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  data?: InputMaybe<Scalars['JSON']>;
  entryType: PointsLedgerEntryType;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

/** All input for the `pointsLedgerIssue` mutation. */
export type PointsLedgerIssueInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Scalars['JSON'];
  note: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The output of our `pointsLedgerIssue` mutation. */
export type PointsLedgerIssuePayload = {
  __typename?: 'PointsLedgerIssuePayload';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  pointsLedger?: Maybe<PointsLedger>;
  /** An edge for our `PointsLedger`. May be used by Relay 1. */
  pointsLedgerEdge?: Maybe<PointsLedgersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `pointsLedgerIssue` mutation. */
export type PointsLedgerIssuePayloadPointsLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};

/** All input for the `pointsLedgerRedeem` mutation. */
export type PointsLedgerRedeemInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  data: Scalars['JSON'];
  note: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The output of our `pointsLedgerRedeem` mutation. */
export type PointsLedgerRedeemPayload = {
  __typename?: 'PointsLedgerRedeemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']>;
};

/** All input for the `pointsLedgerRefund` mutation. */
export type PointsLedgerRefundInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  data: Scalars['JSON'];
  note: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The output of our `pointsLedgerRefund` mutation. */
export type PointsLedgerRefundPayload = {
  __typename?: 'PointsLedgerRefundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `PointsLedger` values. */
export type PointsLedgersConnection = {
  __typename?: 'PointsLedgersConnection';
  /** A list of edges which contains the `PointsLedger` and cursor to aid in pagination. */
  edges: Array<PointsLedgersEdge>;
  /** A list of `PointsLedger` objects. */
  nodes: Array<PointsLedger>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointsLedger` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointsLedger` edge in the connection. */
export type PointsLedgersEdge = {
  __typename?: 'PointsLedgersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointsLedger` at the end of the edge. */
  node: PointsLedger;
};

/** Methods to use when ordering `PointsLedger`. */
export enum PointsLedgersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PotentialProvider = {
  __typename?: 'PotentialProvider';
  distance?: Maybe<Scalars['Float']>;
  /** Reads a single `Provider` that is related to this `PotentialProvider`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
  transactionCount?: Maybe<Scalars['BigInt']>;
};

/** A connection to a list of `PotentialProvider` values. */
export type PotentialProvidersConnection = {
  __typename?: 'PotentialProvidersConnection';
  /** A list of edges which contains the `PotentialProvider` and cursor to aid in pagination. */
  edges: Array<PotentialProvidersEdge>;
  /** A list of `PotentialProvider` objects. */
  nodes: Array<PotentialProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PotentialProvider` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PotentialProvider` edge in the connection. */
export type PotentialProvidersEdge = {
  __typename?: 'PotentialProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PotentialProvider` at the end of the edge. */
  node: PotentialProvider;
};

export type PromoCode = Node & {
  __typename?: 'PromoCode';
  /** Reads a single `Account` that is related to this `PromoCode`. */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  active: Scalars['Boolean'];
  available?: Maybe<Scalars['Boolean']>;
  baseId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `PromoCode`. */
  children: PromoCodesConnection;
  code: Scalars['String'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['UUID']>;
  /** Reads a single `Account` that is related to this `PromoCode`. */
  creator?: Maybe<Account>;
  data: Scalars['JSON'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  monthlyLimit?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PromoCode` that is related to this `PromoCode`. */
  parent?: Maybe<PromoCode>;
  totalLimit?: Maybe<Scalars['Int']>;
};


export type PromoCodeChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PromoCodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodesOrderBy>>;
};

/**
 * A condition to be used against `PromoCode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PromoCodeCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `baseId` field. */
  baseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `PromoCode` */
export type PromoCodeInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  baseId?: InputMaybe<Scalars['UUID']>;
  code: Scalars['String'];
  data: Scalars['JSON'];
  description: Scalars['String'];
  monthlyLimit?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PromoCode` values. */
export type PromoCodesConnection = {
  __typename?: 'PromoCodesConnection';
  /** A list of edges which contains the `PromoCode` and cursor to aid in pagination. */
  edges: Array<PromoCodesEdge>;
  /** A list of `PromoCode` objects. */
  nodes: Array<PromoCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PromoCode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PromoCode` edge in the connection. */
export type PromoCodesEdge = {
  __typename?: 'PromoCodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PromoCode` at the end of the edge. */
  node: PromoCode;
};

/** Methods to use when ordering `PromoCode`. */
export enum PromoCodesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  BaseIdAsc = 'BASE_ID_ASC',
  BaseIdDesc = 'BASE_ID_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Provider = Node & {
  __typename?: 'Provider';
  /** Reads a single `Account` that is related to this `Provider`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  approvalRequested?: Maybe<Scalars['Datetime']>;
  approved?: Maybe<Scalars['Boolean']>;
  areaCenter?: Maybe<Scalars['JSON']>;
  areaUpdated?: Maybe<Scalars['Datetime']>;
  bizDev?: Maybe<Scalars['Boolean']>;
  brokerageName?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['JSON']>;
  connectedTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  docusignExpiration?: Maybe<Scalars['Date']>;
  docusignSigned?: Maybe<Scalars['Date']>;
  docusignStatus?: Maybe<Scalars['String']>;
  email: Scalars['Email'];
  engagebay?: Maybe<Scalars['JSON']>;
  engagebayId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  geoJson?: Maybe<Scalars['JSON']>;
  heshe?: Maybe<Scalars['String']>;
  himher?: Maybe<Scalars['String']>;
  hisher?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads a single `Media` that is related to this `Provider`. */
  image?: Maybe<Media>;
  imageId?: Maybe<Scalars['UUID']>;
  info: Scalars['JSON'];
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection;
  /** Reads and enables pagination through a set of `License`. */
  licenses: LicensesConnection;
  location?: Maybe<Scalars['JSON']>;
  maxPrice?: Maybe<Scalars['Int']>;
  minPrice?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OpenaiThread`. */
  openaiThreads: OpenaiThreadsConnection;
  phone?: Maybe<Scalars['String']>;
  presentedCount?: Maybe<Scalars['Int']>;
  presentedNames?: Maybe<Scalars['JSON']>;
  presentedTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileComplete?: Maybe<Scalars['Int']>;
  pronouns?: Maybe<Scalars['String']>;
  public: Scalars['Boolean'];
  rating?: Maybe<Scalars['Float']>;
  ratingCommunication?: Maybe<Scalars['Float']>;
  ratingLocalKnowledge?: Maybe<Scalars['Float']>;
  ratingResponsiveness?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `Review`. */
  reviews: ReviewsConnection;
  selectedBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  selectedNames?: Maybe<Scalars['JSON']>;
  setupComplete?: Maybe<Scalars['Datetime']>;
  signed?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['Slug']>;
  specialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['JSON']>;
  syntheticStatus?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  transactionHistory: Scalars['JSON'];
  transactionLocations?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `ProviderTransaction`. */
  transactions: ProviderTransactionsConnection;
  type: ProviderType;
  /** Reads and enables pagination through a set of `Media`. */
  unprocessedUploads: MediaConnection;
  website?: Maybe<Scalars['String']>;
};


export type ProviderLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};


export type ProviderLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LicenseCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LicensesOrderBy>>;
};


export type ProviderOpenaiThreadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiThreadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};


export type ProviderReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};


export type ProviderTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProviderTransactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};


export type ProviderUnprocessedUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Provider` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProviderCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['Email']>;
  /** Checks for equality with the object’s `engagebay` field. */
  engagebay?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `imageId` field. */
  imageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['Slug']>;
};

/** Represents an update to a `Provider`. Fields that are set will be updated. */
export type ProviderPatch = {
  accountId?: InputMaybe<Scalars['UUID']>;
  approvalRequested?: InputMaybe<Scalars['Datetime']>;
  areaCenter?: InputMaybe<Scalars['JSON']>;
  areaUpdated?: InputMaybe<Scalars['Datetime']>;
  bizDev?: InputMaybe<Scalars['Boolean']>;
  connectedTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['Email']>;
  engagebay?: InputMaybe<Scalars['JSON']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageId?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['JSON']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  presentedCount?: InputMaybe<Scalars['Int']>;
  presentedTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pronouns?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  selectedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  setupComplete?: InputMaybe<Scalars['Datetime']>;
  slug?: InputMaybe<Scalars['Slug']>;
  specialties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['JSON']>;
  tier?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  transactionHistory?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<ProviderType>;
  website?: InputMaybe<Scalars['String']>;
};

export type ProviderTransaction = Node & {
  __typename?: 'ProviderTransaction';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  closePrice: Scalars['Int'];
  id: Scalars['UUID'];
  location?: Maybe<Scalars['JSON']>;
  lookupFailed?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  state: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `ProviderTransaction` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProviderTransactionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

export type ProviderTransactionCount = {
  __typename?: 'ProviderTransactionCount';
  count?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Provider` that is related to this `ProviderTransactionCount`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `ProviderTransactionCount` values. */
export type ProviderTransactionCountsConnection = {
  __typename?: 'ProviderTransactionCountsConnection';
  /** A list of edges which contains the `ProviderTransactionCount` and cursor to aid in pagination. */
  edges: Array<ProviderTransactionCountsEdge>;
  /** A list of `ProviderTransactionCount` objects. */
  nodes: Array<ProviderTransactionCount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProviderTransactionCount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProviderTransactionCount` edge in the connection. */
export type ProviderTransactionCountsEdge = {
  __typename?: 'ProviderTransactionCountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProviderTransactionCount` at the end of the edge. */
  node: ProviderTransactionCount;
};

/** An input for mutations affecting `ProviderTransaction` */
export type ProviderTransactionInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  closePrice: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  lookupFailed?: InputMaybe<Scalars['Datetime']>;
  providerId: Scalars['UUID'];
  state: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `ProviderTransaction`. Fields that are set will be updated. */
export type ProviderTransactionPatch = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  closePrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupFailed?: InputMaybe<Scalars['Datetime']>;
  providerId?: InputMaybe<Scalars['UUID']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `ProviderTransaction` values. */
export type ProviderTransactionsConnection = {
  __typename?: 'ProviderTransactionsConnection';
  /** A list of edges which contains the `ProviderTransaction` and cursor to aid in pagination. */
  edges: Array<ProviderTransactionsEdge>;
  /** A list of `ProviderTransaction` objects. */
  nodes: Array<ProviderTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProviderTransaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProviderTransaction` edge in the connection. */
export type ProviderTransactionsEdge = {
  __typename?: 'ProviderTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProviderTransaction` at the end of the edge. */
  node: ProviderTransaction;
};

/** Methods to use when ordering `ProviderTransaction`. */
export enum ProviderTransactionsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

export enum ProviderType {
  RealEstateAgent = 'REAL_ESTATE_AGENT'
}

/** A connection to a list of `Provider` values. */
export type ProvidersConnection = {
  __typename?: 'ProvidersConnection';
  /** A list of edges which contains the `Provider` and cursor to aid in pagination. */
  edges: Array<ProvidersEdge>;
  /** A list of `Provider` objects. */
  nodes: Array<Provider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Provider` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Provider` edge in the connection. */
export type ProvidersEdge = {
  __typename?: 'ProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Provider` at the end of the edge. */
  node: Provider;
};

/** Methods to use when ordering `Provider`. */
export enum ProvidersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EngagebayAsc = 'ENGAGEBAY_ASC',
  EngagebayDesc = 'ENGAGEBAY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImageIdAsc = 'IMAGE_ID_ASC',
  ImageIdDesc = 'IMAGE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `Account` using its globally unique `ID`. */
  account?: Maybe<Account>;
  accountByAvatarId?: Maybe<Account>;
  accountById?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Agent`. */
  agentsByCityState?: Maybe<AgentsConnection>;
  /** Reads a single `Alert` using its globally unique `ID`. */
  alert?: Maybe<Alert>;
  alertById?: Maybe<Alert>;
  /** Reads and enables pagination through a set of `Consumer`. */
  allConsumers?: Maybe<ConsumersConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  allProviders?: Maybe<ProvidersConnection>;
  areaCoverage?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  areaPotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** City autocomplete search, sorting by distance from zip. */
  autocompleteLocation?: Maybe<Scalars['JSON']>;
  citiesDistance?: Maybe<Scalars['Float']>;
  cityDistance?: Maybe<Scalars['Float']>;
  cityGeoJson?: Maybe<Scalars['JSON']>;
  cityLocation?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  cityStatePotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** Reads a single `Consumer` using its globally unique `ID`. */
  consumer?: Maybe<Consumer>;
  consumerByAccountId?: Maybe<Consumer>;
  consumerById?: Maybe<Consumer>;
  /** Reads and enables pagination through a set of `Consumer`. */
  consumers?: Maybe<ConsumersConnection>;
  /** Reads and enables pagination through a set of `Consumer`. */
  consumersByLocation?: Maybe<ConsumersConnection>;
  /** Reads a single `Contact` using its globally unique `ID`. */
  contact?: Maybe<Contact>;
  contactById?: Maybe<Contact>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  dealPotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** Reads a single `DocusignEnvelope` using its globally unique `ID`. */
  docusignEnvelope?: Maybe<DocusignEnvelope>;
  docusignEnvelopeByEnvelopeId?: Maybe<DocusignEnvelope>;
  docusignEnvelopeById?: Maybe<DocusignEnvelope>;
  /** Reads a single `DocusignEnvelopeRecipient` using its globally unique `ID`. */
  docusignEnvelopeRecipient?: Maybe<DocusignEnvelopeRecipient>;
  docusignEnvelopeRecipientByDocusignEnvelopeIdAndAccountId?: Maybe<DocusignEnvelopeRecipient>;
  /** Reads and enables pagination through a set of `Provider`. */
  findProviders?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Consumer`. */
  getConsumersByTrack?: Maybe<ConsumersConnection>;
  getNextProviderTransaction?: Maybe<ProviderTransaction>;
  getProviderByEmail?: Maybe<Provider>;
  getProviderByName?: Maybe<Provider>;
  /** Reads and enables pagination through a set of `Inquiry`. */
  inquiries?: Maybe<InquiriesConnection>;
  /** Reads a single `Inquiry` using its globally unique `ID`. */
  inquiry?: Maybe<Inquiry>;
  /** Reads a single `InquiryAddress` using its globally unique `ID`. */
  inquiryAddress?: Maybe<InquiryAddress>;
  inquiryAddressById?: Maybe<InquiryAddress>;
  /** Reads and enables pagination through a set of `InquiryAddress`. */
  inquiryAddresses?: Maybe<InquiryAddressesConnection>;
  inquiryById?: Maybe<Inquiry>;
  /** Reads a single `Invitation` using its globally unique `ID`. */
  invitation?: Maybe<Invitation>;
  invitationById?: Maybe<Invitation>;
  /** Reads a single `Lead` using its globally unique `ID`. */
  lead?: Maybe<Lead>;
  leadById?: Maybe<Lead>;
  /** Reads a single `License` using its globally unique `ID`. */
  license?: Maybe<License>;
  licenseById?: Maybe<License>;
  /** Reads a single `Link` using its globally unique `ID`. */
  link?: Maybe<Link>;
  linkById?: Maybe<Link>;
  /** Reads a single `Log` using its globally unique `ID`. */
  log?: Maybe<Log>;
  /** Reads a single `Media` using its globally unique `ID`. */
  media?: Maybe<Media>;
  mediaById?: Maybe<Media>;
  /** Reads a single `Message` using its globally unique `ID`. */
  message?: Maybe<Message>;
  messageById?: Maybe<Message>;
  /** Find the closest location to the given latitude and longitude. */
  nearestZip?: Maybe<Scalars['JSON']>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Reads a single `Note` using its globally unique `ID`. */
  note?: Maybe<Note>;
  noteById?: Maybe<Note>;
  /** Reads and enables pagination through a set of `Note`. */
  notes?: Maybe<NotesConnection>;
  /** Reads a single `OpenaiAssistant` using its globally unique `ID`. */
  openaiAssistant?: Maybe<OpenaiAssistant>;
  openaiAssistantById?: Maybe<OpenaiAssistant>;
  /** Reads and enables pagination through a set of `OpenaiAssistant`. */
  openaiAssistants?: Maybe<OpenaiAssistantsConnection>;
  /** Reads a single `OpenaiMessage` using its globally unique `ID`. */
  openaiMessage?: Maybe<OpenaiMessage>;
  openaiMessageById?: Maybe<OpenaiMessage>;
  /** Reads and enables pagination through a set of `OpenaiMessage`. */
  openaiMessages?: Maybe<OpenaiMessagesConnection>;
  /** Reads a single `OpenaiRun` using its globally unique `ID`. */
  openaiRun?: Maybe<OpenaiRun>;
  openaiRunById?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiRunStep` using its globally unique `ID`. */
  openaiRunStep?: Maybe<OpenaiRunStep>;
  openaiRunStepById?: Maybe<OpenaiRunStep>;
  /** Reads and enables pagination through a set of `OpenaiRunStep`. */
  openaiRunSteps?: Maybe<OpenaiRunStepsConnection>;
  /** Reads and enables pagination through a set of `OpenaiRun`. */
  openaiRuns?: Maybe<OpenaiRunsConnection>;
  /** Reads a single `OpenaiThread` using its globally unique `ID`. */
  openaiThread?: Maybe<OpenaiThread>;
  openaiThreadById?: Maybe<OpenaiThread>;
  /** Reads and enables pagination through a set of `OpenaiThread`. */
  openaiThreads?: Maybe<OpenaiThreadsConnection>;
  /** Reads a single `Payment` using its globally unique `ID`. */
  payment?: Maybe<Payment>;
  paymentById?: Maybe<Payment>;
  /** Reads a single `PointsLedger` using its globally unique `ID`. */
  pointsLedger?: Maybe<PointsLedger>;
  pointsLedgerById?: Maybe<PointsLedger>;
  /** Reads and enables pagination through a set of `PointsLedger`. */
  pointsLedgers?: Maybe<PointsLedgersConnection>;
  /** Reads a single `PromoCode` using its globally unique `ID`. */
  promoCode?: Maybe<PromoCode>;
  promoCodeByCode?: Maybe<PromoCode>;
  promoCodeById?: Maybe<PromoCode>;
  /** Reads a single `Provider` using its globally unique `ID`. */
  provider?: Maybe<Provider>;
  providerByAccountId?: Maybe<Provider>;
  providerById?: Maybe<Provider>;
  providerByReferralCode?: Maybe<Provider>;
  providerBySlug?: Maybe<Provider>;
  /** Reads a single `ProviderTransaction` using its globally unique `ID`. */
  providerTransaction?: Maybe<ProviderTransaction>;
  providerTransactionById?: Maybe<ProviderTransaction>;
  providerTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<ProviderTransaction>;
  /** Reads and enables pagination through a set of `Provider`. */
  providers?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  providersByCityState?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  providersByLocation?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `ProviderTransactionCount`. */
  providersByTransactionLocation?: Maybe<ProviderTransactionCountsConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  providersNearest?: Maybe<ProvidersConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `Redirect` using its globally unique `ID`. */
  redirect?: Maybe<Redirect>;
  redirectById?: Maybe<Redirect>;
  redirectByPath?: Maybe<Redirect>;
  /** Reads and enables pagination through a set of `Redirect`. */
  redirects?: Maybe<RedirectsConnection>;
  /** Reads a single `Review` using its globally unique `ID`. */
  review?: Maybe<Review>;
  reviewById?: Maybe<Review>;
  /** Reads and enables pagination through a set of `Review`. */
  reviews?: Maybe<ReviewsConnection>;
  setReviewRating?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `UserActivity`. */
  userActivities?: Maybe<UserActivitiesConnection>;
  /** Reads a single `UserActivity` using its globally unique `ID`. */
  userActivity?: Maybe<UserActivity>;
  userActivityById?: Maybe<UserActivity>;
  /** Current user's info. */
  viewer?: Maybe<Account>;
  zipGeoJson?: Maybe<Scalars['JSON']>;
  zipLocation?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  zipPotentialProviders?: Maybe<PotentialProvidersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByAvatarIdArgs = {
  avatarId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAgentsByCityStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAlertArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAlertByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllConsumersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaCoverageArgs = {
  locationId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  area?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAutocompleteLocationArgs = {
  search: Scalars['String'];
  zipCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCitiesDistanceArgs = {
  city1?: InputMaybe<Scalars['String']>;
  city2?: InputMaybe<Scalars['String']>;
  state1?: InputMaybe<Scalars['String']>;
  state2?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityDistanceArgs = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityGeoJsonArgs = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityLocationArgs = {
  _city?: InputMaybe<Scalars['String']>;
  _state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityStatePotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumerByAccountIdArgs = {
  accountId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConsumerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConsumersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumersByLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContactArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDealPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  dealUniqueId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeByEnvelopeIdArgs = {
  envelopeId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeRecipientArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeRecipientByDocusignEnvelopeIdAndAccountIdArgs = {
  accountId: Scalars['UUID'];
  docusignEnvelopeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFindProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProviderType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetConsumersByTrackArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  track?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetNextProviderTransactionArgs = {
  t?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProviderByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProviderByNameArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryAddressArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryAddressByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLicenseArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLicenseByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinkArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinkByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNearestZipArgs = {
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiAssistantArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiAssistantByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiAssistantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiAssistantCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiAssistantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiMessageArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiMessageByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiRunArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiRunByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiRunStepArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiRunStepByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiRunStepsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunStepCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiRunsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiThreadArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiThreadByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenaiThreadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiThreadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointsLedgerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointsLedgerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointsLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointsLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPromoCodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPromoCodeByCodeArgs = {
  code: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPromoCodeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderByAccountIdArgs = {
  accountId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderByReferralCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderBySlugArgs = {
  slug: Scalars['Slug'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderTransactionArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderTransactionByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  address1: Scalars['String'];
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProviderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersByCityStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  miles?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersByLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersByTransactionLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersNearestArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectByPathArgs = {
  path: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RedirectCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RedirectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySetReviewRatingArgs = {
  ratings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserActivityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserActivityArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserActivityByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZipGeoJsonArgs = {
  zipCode?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZipLocationArgs = {
  _zip?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZipPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Redirect = Node & {
  __typename?: 'Redirect';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
};

/**
 * A condition to be used against `Redirect` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RedirectCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `Redirect` */
export type RedirectInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  path: Scalars['String'];
};

/** A connection to a list of `Redirect` values. */
export type RedirectsConnection = {
  __typename?: 'RedirectsConnection';
  /** A list of edges which contains the `Redirect` and cursor to aid in pagination. */
  edges: Array<RedirectsEdge>;
  /** A list of `Redirect` objects. */
  nodes: Array<Redirect>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Redirect` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Redirect` edge in the connection. */
export type RedirectsEdge = {
  __typename?: 'RedirectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Redirect` at the end of the edge. */
  node: Redirect;
};

/** Methods to use when ordering `Redirect`. */
export enum RedirectsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `refreshJwt` mutation. */
export type RefreshJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `refreshJwt` mutation. */
export type RefreshJwtPayload = {
  __typename?: 'RefreshJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `registerConsumerAlt` mutation. */
export type RegisterConsumerAltInput = {
  campaign?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  promoCodeId?: InputMaybe<Scalars['UUID']>;
  referrer?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `registerConsumerAlt` mutation. */
export type RegisterConsumerAltPayload = {
  __typename?: 'RegisterConsumerAltPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']>;
};

/** All input for the `registerConsumer` mutation. */
export type RegisterConsumerInput = {
  campaign?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  inquiryDetails?: InputMaybe<Scalars['JSON']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  promoCodeId?: InputMaybe<Scalars['UUID']>;
  referrer?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `registerConsumer` mutation. */
export type RegisterConsumerPayload = {
  __typename?: 'RegisterConsumerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `registerRealEstateAgent` mutation. */
export type RegisterRealEstateAgentInput = {
  campaign?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  promoCodeId?: InputMaybe<Scalars['UUID']>;
  referrer?: InputMaybe<Scalars['UUID']>;
  serviceAreaZipCode?: InputMaybe<Scalars['String']>;
};

/** The output of our `registerRealEstateAgent` mutation. */
export type RegisterRealEstateAgentPayload = {
  __typename?: 'RegisterRealEstateAgentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeAccount` mutation. */
export type RemoveAccountInput = {
  aid: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `removeAccount` mutation. */
export type RemoveAccountPayload = {
  __typename?: 'RemoveAccountPayload';
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PromoCode` that is related to this `Account`. */
  signupPromoCode?: Maybe<PromoCode>;
};


/** The output of our `removeAccount` mutation. */
export type RemoveAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `resetPassword` mutation. */
export type ResetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** The output of our `resetPassword` mutation. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `restoreAccount` mutation. */
export type RestoreAccountInput = {
  aid: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `restoreAccount` mutation. */
export type RestoreAccountPayload = {
  __typename?: 'RestoreAccountPayload';
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PromoCode` that is related to this `Account`. */
  signupPromoCode?: Maybe<PromoCode>;
};


/** The output of our `restoreAccount` mutation. */
export type RestoreAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

export type Review = Node & {
  __typename?: 'Review';
  /** Reads a single `Account` that is related to this `Review`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  comment?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Review`. */
  consumer?: Maybe<Consumer>;
  consumerId?: Maybe<Scalars['UUID']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Provider` that is related to this `Review`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  rating?: Maybe<Scalars['Float']>;
  ratingCommunication?: Maybe<Scalars['Int']>;
  ratingLocalKnowledge?: Maybe<Scalars['Int']>;
  ratingResponsiveness?: Maybe<Scalars['Int']>;
  reviewer?: Maybe<Scalars['String']>;
  wouldUseAgain?: Maybe<Scalars['Boolean']>;
};

/** A condition to be used against `Review` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ReviewCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `consumerId` field. */
  consumerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Review` */
export type ReviewInput = {
  comment?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['UUID']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  providerId: Scalars['UUID'];
  ratingCommunication?: InputMaybe<Scalars['Int']>;
  ratingLocalKnowledge?: InputMaybe<Scalars['Int']>;
  ratingResponsiveness?: InputMaybe<Scalars['Int']>;
  reviewer?: InputMaybe<Scalars['String']>;
  wouldUseAgain?: InputMaybe<Scalars['Boolean']>;
};

/** Represents an update to a `Review`. Fields that are set will be updated. */
export type ReviewPatch = {
  comment?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['UUID']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  providerId?: InputMaybe<Scalars['UUID']>;
  ratingCommunication?: InputMaybe<Scalars['Int']>;
  ratingLocalKnowledge?: InputMaybe<Scalars['Int']>;
  ratingResponsiveness?: InputMaybe<Scalars['Int']>;
  reviewer?: InputMaybe<Scalars['String']>;
  wouldUseAgain?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `Review` values. */
export type ReviewsConnection = {
  __typename?: 'ReviewsConnection';
  /** A list of edges which contains the `Review` and cursor to aid in pagination. */
  edges: Array<ReviewsEdge>;
  /** A list of `Review` objects. */
  nodes: Array<Review>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Review` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Review` edge in the connection. */
export type ReviewsEdge = {
  __typename?: 'ReviewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Review` at the end of the edge. */
  node: Review;
};

/** Methods to use when ordering `Review`. */
export enum ReviewsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  ConsumerIdAsc = 'CONSUMER_ID_ASC',
  ConsumerIdDesc = 'CONSUMER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

/** All input for the `sendPhoneVerify` mutation. */
export type SendPhoneVerifyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['UUID'];
};

/** The output of our `sendPhoneVerify` mutation. */
export type SendPhoneVerifyPayload = {
  __typename?: 'SendPhoneVerifyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendSmsLoginToken` mutation. */
export type SendSmsLoginTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** The output of our `sendSmsLoginToken` mutation. */
export type SendSmsLoginTokenPayload = {
  __typename?: 'SendSmsLoginTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendVerificationCode` mutation. */
export type SendVerificationCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['UUID'];
};

/** The output of our `sendVerificationCode` mutation. */
export type SendVerificationCodePayload = {
  __typename?: 'SendVerificationCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setPassword` mutation. */
export type SetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

/** The output of our `setPassword` mutation. */
export type SetPasswordPayload = {
  __typename?: 'SetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type Subscription = {
  __typename?: 'Subscription';
  /** Reads a single `Account` using its globally unique `ID`. (live) */
  account?: Maybe<Account>;
  /**  (live) */
  accountByAvatarId?: Maybe<Account>;
  /**  (live) */
  accountById?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Agent`. (live) */
  agentsByCityState?: Maybe<AgentsConnection>;
  /** Reads a single `Alert` using its globally unique `ID`. (live) */
  alert?: Maybe<Alert>;
  /**  (live) */
  alertById?: Maybe<Alert>;
  /** Reads and enables pagination through a set of `Consumer`. (live) */
  allConsumers?: Maybe<ConsumersConnection>;
  /** Reads and enables pagination through a set of `Provider`. (live) */
  allProviders?: Maybe<ProvidersConnection>;
  /**  (live) */
  areaCoverage?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. (live) */
  areaPotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** City autocomplete search, sorting by distance from zip. (live) */
  autocompleteLocation?: Maybe<Scalars['JSON']>;
  /**  (live) */
  citiesDistance?: Maybe<Scalars['Float']>;
  /**  (live) */
  cityDistance?: Maybe<Scalars['Float']>;
  /**  (live) */
  cityGeoJson?: Maybe<Scalars['JSON']>;
  /**  (live) */
  cityLocation?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. (live) */
  cityStatePotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** Reads a single `Consumer` using its globally unique `ID`. (live) */
  consumer?: Maybe<Consumer>;
  /**  (live) */
  consumerByAccountId?: Maybe<Consumer>;
  /**  (live) */
  consumerById?: Maybe<Consumer>;
  /** Reads and enables pagination through a set of `Consumer`. (live) */
  consumers?: Maybe<ConsumersConnection>;
  /** Reads and enables pagination through a set of `Consumer`. (live) */
  consumersByLocation?: Maybe<ConsumersConnection>;
  /** Reads a single `Contact` using its globally unique `ID`. (live) */
  contact?: Maybe<Contact>;
  /**  (live) */
  contactById?: Maybe<Contact>;
  /** Reads and enables pagination through a set of `PotentialProvider`. (live) */
  dealPotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** Reads a single `DocusignEnvelope` using its globally unique `ID`. (live) */
  docusignEnvelope?: Maybe<DocusignEnvelope>;
  /**  (live) */
  docusignEnvelopeByEnvelopeId?: Maybe<DocusignEnvelope>;
  /**  (live) */
  docusignEnvelopeById?: Maybe<DocusignEnvelope>;
  /** Reads a single `DocusignEnvelopeRecipient` using its globally unique `ID`. (live) */
  docusignEnvelopeRecipient?: Maybe<DocusignEnvelopeRecipient>;
  /**  (live) */
  docusignEnvelopeRecipientByDocusignEnvelopeIdAndAccountId?: Maybe<DocusignEnvelopeRecipient>;
  /** Reads and enables pagination through a set of `Provider`. (live) */
  findProviders?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Consumer`. (live) */
  getConsumersByTrack?: Maybe<ConsumersConnection>;
  /**  (live) */
  getNextProviderTransaction?: Maybe<ProviderTransaction>;
  /**  (live) */
  getProviderByEmail?: Maybe<Provider>;
  /**  (live) */
  getProviderByName?: Maybe<Provider>;
  /** Reads and enables pagination through a set of `Inquiry`. (live) */
  inquiries?: Maybe<InquiriesConnection>;
  /** Reads a single `Inquiry` using its globally unique `ID`. (live) */
  inquiry?: Maybe<Inquiry>;
  /** Reads a single `InquiryAddress` using its globally unique `ID`. (live) */
  inquiryAddress?: Maybe<InquiryAddress>;
  /**  (live) */
  inquiryAddressById?: Maybe<InquiryAddress>;
  /** Reads and enables pagination through a set of `InquiryAddress`. (live) */
  inquiryAddresses?: Maybe<InquiryAddressesConnection>;
  /**  (live) */
  inquiryById?: Maybe<Inquiry>;
  /** Reads a single `Invitation` using its globally unique `ID`. (live) */
  invitation?: Maybe<Invitation>;
  /**  (live) */
  invitationById?: Maybe<Invitation>;
  /** Reads a single `Lead` using its globally unique `ID`. (live) */
  lead?: Maybe<Lead>;
  /**  (live) */
  leadById?: Maybe<Lead>;
  /** Reads a single `License` using its globally unique `ID`. (live) */
  license?: Maybe<License>;
  /**  (live) */
  licenseById?: Maybe<License>;
  /** Reads a single `Link` using its globally unique `ID`. (live) */
  link?: Maybe<Link>;
  /**  (live) */
  linkById?: Maybe<Link>;
  listen: ListenPayload;
  /** Reads a single `Log` using its globally unique `ID`. (live) */
  log?: Maybe<Log>;
  /** Reads a single `Media` using its globally unique `ID`. (live) */
  media?: Maybe<Media>;
  /**  (live) */
  mediaById?: Maybe<Media>;
  /** Reads a single `Message` using its globally unique `ID`. (live) */
  message?: Maybe<Message>;
  /**  (live) */
  messageById?: Maybe<Message>;
  /** Find the closest location to the given latitude and longitude. (live) */
  nearestZip?: Maybe<Scalars['JSON']>;
  /** Fetches an object given its globally unique `ID`. (live) */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. (live) */
  nodeId: Scalars['ID'];
  /** Reads a single `Note` using its globally unique `ID`. (live) */
  note?: Maybe<Note>;
  /**  (live) */
  noteById?: Maybe<Note>;
  /** Reads and enables pagination through a set of `Note`. (live) */
  notes?: Maybe<NotesConnection>;
  /** Reads a single `OpenaiAssistant` using its globally unique `ID`. (live) */
  openaiAssistant?: Maybe<OpenaiAssistant>;
  /**  (live) */
  openaiAssistantById?: Maybe<OpenaiAssistant>;
  /** Reads and enables pagination through a set of `OpenaiAssistant`. (live) */
  openaiAssistants?: Maybe<OpenaiAssistantsConnection>;
  /** Reads a single `OpenaiMessage` using its globally unique `ID`. (live) */
  openaiMessage?: Maybe<OpenaiMessage>;
  /**  (live) */
  openaiMessageById?: Maybe<OpenaiMessage>;
  /** Reads and enables pagination through a set of `OpenaiMessage`. (live) */
  openaiMessages?: Maybe<OpenaiMessagesConnection>;
  /** Reads a single `OpenaiRun` using its globally unique `ID`. (live) */
  openaiRun?: Maybe<OpenaiRun>;
  /**  (live) */
  openaiRunById?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiRunStep` using its globally unique `ID`. (live) */
  openaiRunStep?: Maybe<OpenaiRunStep>;
  /**  (live) */
  openaiRunStepById?: Maybe<OpenaiRunStep>;
  /** Reads and enables pagination through a set of `OpenaiRunStep`. (live) */
  openaiRunSteps?: Maybe<OpenaiRunStepsConnection>;
  /** Reads and enables pagination through a set of `OpenaiRun`. (live) */
  openaiRuns?: Maybe<OpenaiRunsConnection>;
  /** Reads a single `OpenaiThread` using its globally unique `ID`. (live) */
  openaiThread?: Maybe<OpenaiThread>;
  /**  (live) */
  openaiThreadById?: Maybe<OpenaiThread>;
  /** Reads and enables pagination through a set of `OpenaiThread`. (live) */
  openaiThreads?: Maybe<OpenaiThreadsConnection>;
  /** Reads a single `Payment` using its globally unique `ID`. (live) */
  payment?: Maybe<Payment>;
  /**  (live) */
  paymentById?: Maybe<Payment>;
  /** Reads a single `PointsLedger` using its globally unique `ID`. (live) */
  pointsLedger?: Maybe<PointsLedger>;
  /**  (live) */
  pointsLedgerById?: Maybe<PointsLedger>;
  /** Reads and enables pagination through a set of `PointsLedger`. (live) */
  pointsLedgers?: Maybe<PointsLedgersConnection>;
  /** Reads a single `PromoCode` using its globally unique `ID`. (live) */
  promoCode?: Maybe<PromoCode>;
  /**  (live) */
  promoCodeByCode?: Maybe<PromoCode>;
  /**  (live) */
  promoCodeById?: Maybe<PromoCode>;
  /** Reads a single `Provider` using its globally unique `ID`. (live) */
  provider?: Maybe<Provider>;
  /**  (live) */
  providerByAccountId?: Maybe<Provider>;
  /**  (live) */
  providerById?: Maybe<Provider>;
  /**  (live) */
  providerByReferralCode?: Maybe<Provider>;
  /**  (live) */
  providerBySlug?: Maybe<Provider>;
  /** Reads a single `ProviderTransaction` using its globally unique `ID`. (live) */
  providerTransaction?: Maybe<ProviderTransaction>;
  /**  (live) */
  providerTransactionById?: Maybe<ProviderTransaction>;
  /**  (live) */
  providerTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<ProviderTransaction>;
  /** Reads and enables pagination through a set of `Provider`. (live) */
  providers?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Provider`. (live) */
  providersByCityState?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Provider`. (live) */
  providersByLocation?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `ProviderTransactionCount`. (live) */
  providersByTransactionLocation?: Maybe<ProviderTransactionCountsConnection>;
  /** Reads and enables pagination through a set of `Provider`. (live) */
  providersNearest?: Maybe<ProvidersConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form. (live)
   */
  query: Query;
  /** Reads a single `Redirect` using its globally unique `ID`. (live) */
  redirect?: Maybe<Redirect>;
  /**  (live) */
  redirectById?: Maybe<Redirect>;
  /**  (live) */
  redirectByPath?: Maybe<Redirect>;
  /** Reads and enables pagination through a set of `Redirect`. (live) */
  redirects?: Maybe<RedirectsConnection>;
  /** Reads a single `Review` using its globally unique `ID`. (live) */
  review?: Maybe<Review>;
  /**  (live) */
  reviewById?: Maybe<Review>;
  /** Reads and enables pagination through a set of `Review`. (live) */
  reviews?: Maybe<ReviewsConnection>;
  /**  (live) */
  setReviewRating?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `UserActivity`. (live) */
  userActivities?: Maybe<UserActivitiesConnection>;
  /** Reads a single `UserActivity` using its globally unique `ID`. (live) */
  userActivity?: Maybe<UserActivity>;
  /**  (live) */
  userActivityById?: Maybe<UserActivity>;
  /** Current user's info. (live) */
  viewer?: Maybe<Account>;
  /**  (live) */
  zipGeoJson?: Maybe<Scalars['JSON']>;
  /**  (live) */
  zipLocation?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. (live) */
  zipPotentialProviders?: Maybe<PotentialProvidersConnection>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAccountArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAccountByAvatarIdArgs = {
  avatarId: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAccountByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAgentsByCityStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAlertArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAlertByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllConsumersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSON']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSON']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAreaCoverageArgs = {
  locationId: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAreaPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  area?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAutocompleteLocationArgs = {
  search: Scalars['String'];
  zipCode: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCitiesDistanceArgs = {
  city1?: InputMaybe<Scalars['String']>;
  city2?: InputMaybe<Scalars['String']>;
  state1?: InputMaybe<Scalars['String']>;
  state2?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCityDistanceArgs = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  state?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCityGeoJsonArgs = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCityLocationArgs = {
  _city?: InputMaybe<Scalars['String']>;
  _state?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCityStatePotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionConsumerArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionConsumerByAccountIdArgs = {
  accountId: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionConsumerByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionConsumersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConsumerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConsumersOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionConsumersByLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContactArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContactByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDealPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  dealUniqueId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDocusignEnvelopeArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDocusignEnvelopeByEnvelopeIdArgs = {
  envelopeId: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDocusignEnvelopeByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDocusignEnvelopeRecipientArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDocusignEnvelopeRecipientByDocusignEnvelopeIdAndAccountIdArgs = {
  accountId: Scalars['UUID'];
  docusignEnvelopeId: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFindProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProviderType>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGetConsumersByTrackArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  track?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGetNextProviderTransactionArgs = {
  t?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGetProviderByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGetProviderByNameArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInquiriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInquiryArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInquiryAddressArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInquiryAddressByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInquiryAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInquiryByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInvitationArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionInvitationByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLeadArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLeadByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLicenseArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLicenseByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLinkArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLinkByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionListenArgs = {
  topic: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionLogArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionMediaArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionMediaByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionMessageArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionMessageByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionNearestZipArgs = {
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionNodeArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionNoteArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionNoteByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiAssistantArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiAssistantByIdArgs = {
  id: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiAssistantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiAssistantCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiAssistantsOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiMessageArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiMessageByIdArgs = {
  id: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiRunArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiRunByIdArgs = {
  id: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiRunStepArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiRunStepByIdArgs = {
  id: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiRunStepsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunStepCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiRunsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiRunCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiThreadArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiThreadByIdArgs = {
  id: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOpenaiThreadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpenaiThreadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPaymentArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPaymentByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPointsLedgerArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPointsLedgerByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPointsLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointsLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPromoCodeArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPromoCodeByCodeArgs = {
  code: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPromoCodeByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderByAccountIdArgs = {
  accountId: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderByReferralCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderBySlugArgs = {
  slug: Scalars['Slug'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderTransactionArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderTransactionByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  address1: Scalars['String'];
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProviderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProvidersByCityStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  miles?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProvidersByLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProvidersByTransactionLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProvidersNearestArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionRedirectArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionRedirectByIdArgs = {
  id: Scalars['Int'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionRedirectByPathArgs = {
  path: Scalars['String'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionRedirectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RedirectCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RedirectsOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionReviewArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionReviewByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionSetReviewRatingArgs = {
  ratings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserActivityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserActivityArgs = {
  nodeId: Scalars['ID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserActivityByIdArgs = {
  id: Scalars['UUID'];
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionZipGeoJsonArgs = {
  zipCode?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionZipLocationArgs = {
  _zip?: InputMaybe<Scalars['String']>;
};


/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionZipPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** All input for the `tokenLogin` mutation. */
export type TokenLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['UUID'];
};

/** The output of our `tokenLogin` mutation. */
export type TokenLoginPayload = {
  __typename?: 'TokenLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAccountByAvatarId` mutation. */
export type UpdateAccountByAvatarIdInput = {
  avatarId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Account` being updated. */
  patch: AccountPatch;
};

/** All input for the `updateAccountById` mutation. */
export type UpdateAccountByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Account` being updated. */
  patch: AccountPatch;
};

/** All input for the `updateAccount` mutation. */
export type UpdateAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Account` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Account` being updated. */
  patch: AccountPatch;
};

/** The output of our update `Account` mutation. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  /** The `Account` that was updated by this mutation. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PromoCode` that is related to this `Account`. */
  signupPromoCode?: Maybe<PromoCode>;
};


/** The output of our update `Account` mutation. */
export type UpdateAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `updateAlertById` mutation. */
export type UpdateAlertByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Alert` being updated. */
  patch: AlertPatch;
};

/** All input for the `updateAlert` mutation. */
export type UpdateAlertInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Alert` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Alert` being updated. */
  patch: AlertPatch;
};

/** The output of our update `Alert` mutation. */
export type UpdateAlertPayload = {
  __typename?: 'UpdateAlertPayload';
  /** Reads a single `Account` that is related to this `Alert`. */
  account?: Maybe<Account>;
  /** The `Alert` that was updated by this mutation. */
  alert?: Maybe<Alert>;
  /** An edge for our `Alert`. May be used by Relay 1. */
  alertEdge?: Maybe<AlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Alert` mutation. */
export type UpdateAlertPayloadAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<AlertsOrderBy>>;
};

/** All input for the `updateConsumerByAccountId` mutation. */
export type UpdateConsumerByAccountIdInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Consumer` being updated. */
  patch: ConsumerPatch;
};

/** All input for the `updateConsumerById` mutation. */
export type UpdateConsumerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Consumer` being updated. */
  patch: ConsumerPatch;
};

/** All input for the `updateConsumer` mutation. */
export type UpdateConsumerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Consumer` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Consumer` being updated. */
  patch: ConsumerPatch;
};

/** The output of our update `Consumer` mutation. */
export type UpdateConsumerPayload = {
  __typename?: 'UpdateConsumerPayload';
  /** Reads a single `Account` that is related to this `Consumer`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Consumer` that was updated by this mutation. */
  consumer?: Maybe<Consumer>;
  /** An edge for our `Consumer`. May be used by Relay 1. */
  consumerEdge?: Maybe<ConsumersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Consumer` mutation. */
export type UpdateConsumerPayloadConsumerEdgeArgs = {
  orderBy?: InputMaybe<Array<ConsumersOrderBy>>;
};

/** All input for the `updateDealAddressPrice` mutation. */
export type UpdateDealAddressPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  price?: InputMaybe<Scalars['BigFloat']>;
};

/** The output of our `updateDealAddressPrice` mutation. */
export type UpdateDealAddressPricePayload = {
  __typename?: 'UpdateDealAddressPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateGeoJson` mutation. */
export type UpdateGeoJsonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  geoJson?: InputMaybe<Scalars['JSON']>;
  pid?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `updateGeoJson` mutation. */
export type UpdateGeoJsonPayload = {
  __typename?: 'UpdateGeoJsonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateInquiryAddressById` mutation. */
export type UpdateInquiryAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `InquiryAddress` being updated. */
  patch: InquiryAddressPatch;
};

/** All input for the `updateInquiryAddress` mutation. */
export type UpdateInquiryAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InquiryAddress` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InquiryAddress` being updated. */
  patch: InquiryAddressPatch;
};

/** The output of our update `InquiryAddress` mutation. */
export type UpdateInquiryAddressPayload = {
  __typename?: 'UpdateInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  /** The `InquiryAddress` that was updated by this mutation. */
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InquiryAddress` mutation. */
export type UpdateInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the `updateInquiryById` mutation. */
export type UpdateInquiryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Inquiry` being updated. */
  patch: InquiryPatch;
};

/** All input for the `updateInquiry` mutation. */
export type UpdateInquiryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Inquiry` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Inquiry` being updated. */
  patch: InquiryPatch;
};

/** The output of our update `Inquiry` mutation. */
export type UpdateInquiryPayload = {
  __typename?: 'UpdateInquiryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Inquiry`. */
  consumer?: Maybe<Consumer>;
  /** The `Inquiry` that was updated by this mutation. */
  inquiry?: Maybe<Inquiry>;
  /** An edge for our `Inquiry`. May be used by Relay 1. */
  inquiryEdge?: Maybe<InquiriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Inquiry` mutation. */
export type UpdateInquiryPayloadInquiryEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};

/** All input for the `updateLeadById` mutation. */
export type UpdateLeadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch;
};

/** All input for the `updateLead` mutation. */
export type UpdateLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Lead` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch;
};

/** The output of our update `Lead` mutation. */
export type UpdateLeadPayload = {
  __typename?: 'UpdateLeadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `Lead`. */
  inquiry?: Maybe<Inquiry>;
  /** The `Lead` that was updated by this mutation. */
  lead?: Maybe<Lead>;
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>;
  /** Reads a single `Provider` that is related to this `Lead`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Lead` mutation. */
export type UpdateLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};

/** All input for the `updateLicenseById` mutation. */
export type UpdateLicenseByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `License` being updated. */
  patch: LicensePatch;
};

/** All input for the `updateLicenseGeoJson` mutation. */
export type UpdateLicenseGeoJsonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  geoJson?: InputMaybe<Scalars['JSON']>;
  lid?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `updateLicenseGeoJson` mutation. */
export type UpdateLicenseGeoJsonPayload = {
  __typename?: 'UpdateLicenseGeoJsonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateLicense` mutation. */
export type UpdateLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `License` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `License` being updated. */
  patch: LicensePatch;
};

/** The output of our update `License` mutation. */
export type UpdateLicensePayload = {
  __typename?: 'UpdateLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `License` that was updated by this mutation. */
  license?: Maybe<License>;
  /** An edge for our `License`. May be used by Relay 1. */
  licenseEdge?: Maybe<LicensesEdge>;
  /** Reads a single `Provider` that is related to this `License`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `License` mutation. */
export type UpdateLicensePayloadLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<LicensesOrderBy>>;
};

/** All input for the `updateNoteById` mutation. */
export type UpdateNoteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Note` being updated. */
  patch: NotePatch;
};

/** All input for the `updateNote` mutation. */
export type UpdateNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Note` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Note` being updated. */
  patch: NotePatch;
};

/** The output of our update `Note` mutation. */
export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  /** Reads a single `Account` that is related to this `Note`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Note` that was updated by this mutation. */
  note?: Maybe<Note>;
  /** An edge for our `Note`. May be used by Relay 1. */
  noteEdge?: Maybe<NotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Note` mutation. */
export type UpdateNotePayloadNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};

/** All input for the `updateOpenaiAssistantById` mutation. */
export type UpdateOpenaiAssistantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `OpenaiAssistant` being updated. */
  patch: OpenaiAssistantPatch;
};

/** All input for the `updateOpenaiAssistant` mutation. */
export type UpdateOpenaiAssistantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiAssistant` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OpenaiAssistant` being updated. */
  patch: OpenaiAssistantPatch;
};

/** The output of our update `OpenaiAssistant` mutation. */
export type UpdateOpenaiAssistantPayload = {
  __typename?: 'UpdateOpenaiAssistantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiAssistant` that was updated by this mutation. */
  openaiAssistant?: Maybe<OpenaiAssistant>;
  /** An edge for our `OpenaiAssistant`. May be used by Relay 1. */
  openaiAssistantEdge?: Maybe<OpenaiAssistantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OpenaiAssistant` mutation. */
export type UpdateOpenaiAssistantPayloadOpenaiAssistantEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiAssistantsOrderBy>>;
};

/** All input for the `updateOpenaiMessageById` mutation. */
export type UpdateOpenaiMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `OpenaiMessage` being updated. */
  patch: OpenaiMessagePatch;
};

/** All input for the `updateOpenaiMessage` mutation. */
export type UpdateOpenaiMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiMessage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OpenaiMessage` being updated. */
  patch: OpenaiMessagePatch;
};

/** The output of our update `OpenaiMessage` mutation. */
export type UpdateOpenaiMessagePayload = {
  __typename?: 'UpdateOpenaiMessagePayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiMessage`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiMessage` that was updated by this mutation. */
  openaiMessage?: Maybe<OpenaiMessage>;
  /** An edge for our `OpenaiMessage`. May be used by Relay 1. */
  openaiMessageEdge?: Maybe<OpenaiMessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiRun` that is related to this `OpenaiMessage`. */
  run?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiMessage`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our update `OpenaiMessage` mutation. */
export type UpdateOpenaiMessagePayloadOpenaiMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiMessagesOrderBy>>;
};

/** All input for the `updateOpenaiRunById` mutation. */
export type UpdateOpenaiRunByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `OpenaiRun` being updated. */
  patch: OpenaiRunPatch;
};

/** All input for the `updateOpenaiRun` mutation. */
export type UpdateOpenaiRunInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiRun` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OpenaiRun` being updated. */
  patch: OpenaiRunPatch;
};

/** The output of our update `OpenaiRun` mutation. */
export type UpdateOpenaiRunPayload = {
  __typename?: 'UpdateOpenaiRunPayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRun`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiRun` that was updated by this mutation. */
  openaiRun?: Maybe<OpenaiRun>;
  /** An edge for our `OpenaiRun`. May be used by Relay 1. */
  openaiRunEdge?: Maybe<OpenaiRunsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRun`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our update `OpenaiRun` mutation. */
export type UpdateOpenaiRunPayloadOpenaiRunEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiRunsOrderBy>>;
};

/** All input for the `updateOpenaiRunStepById` mutation. */
export type UpdateOpenaiRunStepByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `OpenaiRunStep` being updated. */
  patch: OpenaiRunStepPatch;
};

/** All input for the `updateOpenaiRunStep` mutation. */
export type UpdateOpenaiRunStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiRunStep` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OpenaiRunStep` being updated. */
  patch: OpenaiRunStepPatch;
};

/** The output of our update `OpenaiRunStep` mutation. */
export type UpdateOpenaiRunStepPayload = {
  __typename?: 'UpdateOpenaiRunStepPayload';
  /** Reads a single `OpenaiAssistant` that is related to this `OpenaiRunStep`. */
  assistant?: Maybe<OpenaiAssistant>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OpenaiRunStep` that was updated by this mutation. */
  openaiRunStep?: Maybe<OpenaiRunStep>;
  /** An edge for our `OpenaiRunStep`. May be used by Relay 1. */
  openaiRunStepEdge?: Maybe<OpenaiRunStepsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `OpenaiRun` that is related to this `OpenaiRunStep`. */
  run?: Maybe<OpenaiRun>;
  /** Reads a single `OpenaiThread` that is related to this `OpenaiRunStep`. */
  thread?: Maybe<OpenaiThread>;
};


/** The output of our update `OpenaiRunStep` mutation. */
export type UpdateOpenaiRunStepPayloadOpenaiRunStepEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiRunStepsOrderBy>>;
};

/** All input for the `updateOpenaiThreadById` mutation. */
export type UpdateOpenaiThreadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `OpenaiThread` being updated. */
  patch: OpenaiThreadPatch;
};

/** All input for the `updateOpenaiThread` mutation. */
export type UpdateOpenaiThreadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OpenaiThread` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OpenaiThread` being updated. */
  patch: OpenaiThreadPatch;
};

/** The output of our update `OpenaiThread` mutation. */
export type UpdateOpenaiThreadPayload = {
  __typename?: 'UpdateOpenaiThreadPayload';
  /** Reads a single `Account` that is related to this `OpenaiThread`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `OpenaiThread`. */
  consumer?: Maybe<Consumer>;
  /** The `OpenaiThread` that was updated by this mutation. */
  openaiThread?: Maybe<OpenaiThread>;
  /** An edge for our `OpenaiThread`. May be used by Relay 1. */
  openaiThreadEdge?: Maybe<OpenaiThreadsEdge>;
  /** Reads a single `Provider` that is related to this `OpenaiThread`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OpenaiThread` mutation. */
export type UpdateOpenaiThreadPayloadOpenaiThreadEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenaiThreadsOrderBy>>;
};

/** All input for the `updateProviderByAccountId` mutation. */
export type UpdateProviderByAccountIdInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
};

/** All input for the `updateProviderById` mutation. */
export type UpdateProviderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
};

/** All input for the `updateProviderBySlug` mutation. */
export type UpdateProviderBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
  slug: Scalars['Slug'];
};

/** All input for the `updateProvider` mutation. */
export type UpdateProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Provider` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
};

/** The output of our update `Provider` mutation. */
export type UpdateProviderPayload = {
  __typename?: 'UpdateProviderPayload';
  /** Reads a single `Account` that is related to this `Provider`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Media` that is related to this `Provider`. */
  image?: Maybe<Media>;
  /** The `Provider` that was updated by this mutation. */
  provider?: Maybe<Provider>;
  /** An edge for our `Provider`. May be used by Relay 1. */
  providerEdge?: Maybe<ProvidersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Provider` mutation. */
export type UpdateProviderPayloadProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};

/** All input for the `updateProviderTransactionById` mutation. */
export type UpdateProviderTransactionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProviderTransaction` being updated. */
  patch: ProviderTransactionPatch;
};

/** All input for the `updateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate` mutation. */
export type UpdateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput = {
  address1: Scalars['String'];
  city: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  closeDate: Scalars['Date'];
  /** An object where the defined keys will be set on the `ProviderTransaction` being updated. */
  patch: ProviderTransactionPatch;
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};

/** All input for the `updateProviderTransaction` mutation. */
export type UpdateProviderTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProviderTransaction` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProviderTransaction` being updated. */
  patch: ProviderTransactionPatch;
};

/** The output of our update `ProviderTransaction` mutation. */
export type UpdateProviderTransactionPayload = {
  __typename?: 'UpdateProviderTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  /** The `ProviderTransaction` that was updated by this mutation. */
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProviderTransaction` mutation. */
export type UpdateProviderTransactionPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** All input for the `updateReviewById` mutation. */
export type UpdateReviewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Review` being updated. */
  patch: ReviewPatch;
};

/** All input for the `updateReview` mutation. */
export type UpdateReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Review` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Review` being updated. */
  patch: ReviewPatch;
};

/** The output of our update `Review` mutation. */
export type UpdateReviewPayload = {
  __typename?: 'UpdateReviewPayload';
  /** Reads a single `Account` that is related to this `Review`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Review`. */
  consumer?: Maybe<Consumer>;
  /** Reads a single `Provider` that is related to this `Review`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Review` that was updated by this mutation. */
  review?: Maybe<Review>;
  /** An edge for our `Review`. May be used by Relay 1. */
  reviewEdge?: Maybe<ReviewsEdge>;
};


/** The output of our update `Review` mutation. */
export type UpdateReviewPayloadReviewEdgeArgs = {
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
};

/** All input for the `updateTransactionLocation` mutation. */
export type UpdateTransactionLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
};

/** All input for the `updateTransactionLocationLookupFailed` mutation. */
export type UpdateTransactionLocationLookupFailedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our `updateTransactionLocationLookupFailed` mutation. */
export type UpdateTransactionLocationLookupFailedPayload = {
  __typename?: 'UpdateTransactionLocationLookupFailedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateTransactionLocationLookupFailed` mutation. */
export type UpdateTransactionLocationLookupFailedPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** The output of our `updateTransactionLocation` mutation. */
export type UpdateTransactionLocationPayload = {
  __typename?: 'UpdateTransactionLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateTransactionLocation` mutation. */
export type UpdateTransactionLocationPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** A connection to a list of `UserActivity` values. */
export type UserActivitiesConnection = {
  __typename?: 'UserActivitiesConnection';
  /** A list of edges which contains the `UserActivity` and cursor to aid in pagination. */
  edges: Array<UserActivitiesEdge>;
  /** A list of `UserActivity` objects. */
  nodes: Array<UserActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserActivity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserActivity` edge in the connection. */
export type UserActivitiesEdge = {
  __typename?: 'UserActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserActivity` at the end of the edge. */
  node: UserActivity;
};

/** Methods to use when ordering `UserActivity`. */
export enum UserActivitiesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type UserActivity = Node & {
  __typename?: 'UserActivity';
  /** Reads a single `Account` that is related to this `UserActivity`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  instanceId: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
};

/**
 * A condition to be used against `UserActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserActivityCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `UserActivity` */
export type UserActivityInput = {
  data?: InputMaybe<Scalars['JSON']>;
  instanceId: Scalars['String'];
  path: Scalars['String'];
};

/** All input for the `verifyContact` mutation. */
export type VerifyContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  contactId: Scalars['UUID'];
};

/** The output of our `verifyContact` mutation. */
export type VerifyContactPayload = {
  __typename?: 'VerifyContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  verifyContactResult?: Maybe<VerifyContactResult>;
};

export type VerifyContactResult = {
  __typename?: 'VerifyContactResult';
  message?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

/** All input for the `verify` mutation. */
export type VerifyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  verificationId: Scalars['UUID'];
};

/** The output of our `verify` mutation. */
export type VerifyPayload = {
  __typename?: 'VerifyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AccountByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AccountByIdQuery = { __typename?: 'Query', accountById?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, id: any, type: string, value: any }> } } | null };

export type AdminUpdateAccountMutationVariables = Exact<{
  input: AdminUpdateAccountInput;
}>;


export type AdminUpdateAccountMutation = { __typename?: 'Mutation', adminUpdateAccount?: { __typename?: 'AdminUpdateAccountPayload', account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, id: any, type: string, value: any }> }, provider?: { __typename?: 'Provider', nodeId: string, name: string, email: any } | null } | null } | null };

export type AgentsByCityStateQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
}>;


export type AgentsByCityStateQuery = { __typename?: 'Query', agentsByCityState?: { __typename?: 'AgentsConnection', nodes: Array<{ __typename?: 'Agent', firstName?: string | null, lastName?: string | null, email?: string | null, companyName?: string | null, companyAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, companyPhone?: string | null, phone?: string | null }> } | null };

export type AutocompleteLocationQueryVariables = Exact<{
  search: Scalars['String'];
  zipCode: Scalars['String'];
}>;


export type AutocompleteLocationQuery = { __typename?: 'Query', autocompleteLocation?: any | null };

export type CityGeoJsonQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type CityGeoJsonQuery = { __typename?: 'Query', cityGeoJson?: any | null };

export type ConsumerDataFragment = { __typename?: 'Consumer', nodeId: string, id: any, vendors?: any | null, createdAt: any, engagebay?: any | null, deletedAt?: any | null, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, email?: any | null, pointsAvailable?: number | null, deletedAt?: any | null, pointsLedger: { __typename?: 'PointsLedgersConnection', nodes: Array<{ __typename?: 'PointsLedger', nodeId: string, id: any, entryType: PointsLedgerEntryType, quantity: number, note?: string | null, createdAt: any, accountByCreatedBy?: { __typename?: 'Account', firstName: string, lastName: string, nodeId: string, id: any } | null }> } } | null, inquiries: { __typename?: 'InquiriesConnection', nodes: Array<{ __typename?: 'Inquiry', details: any }> } } & { ' $fragmentName'?: 'ConsumerDataFragment' };

export type ConsumerByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ConsumerByIdQuery = { __typename?: 'Query', consumerById?: { __typename?: 'Consumer', nodeId: string, id: any, vendors?: any | null, createdAt: any, engagebay?: any | null, providersInArea?: string | null, consultation?: any | null, deletedAt?: any | null, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, suppressMessages?: boolean | null, campaign?: any | null, pointsAvailable?: number | null, deletedAt?: any | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any, verifiedAt?: any | null, undeliverableAt?: any | null }> }, invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', firstName: string, lastName: string, phone?: string | null, email: any, createdAt: any }> }, pointsLedger: { __typename?: 'PointsLedgersConnection', nodes: Array<{ __typename?: 'PointsLedger', nodeId: string, id: any, entryType: PointsLedgerEntryType, quantity: number, note?: string | null, createdAt: any, accountByCreatedBy?: { __typename?: 'Account', firstName: string, lastName: string, nodeId: string, id: any } | null }> } } | null, inquiries: { __typename?: 'InquiriesConnection', nodes: Array<{ __typename?: 'Inquiry', nodeId: string, id: any, details: any, detailsConfirmed?: any | null, providers?: any | null, flags?: any | null, inquiryAddresses: { __typename?: 'InquiryAddressesConnection', nodes: Array<{ __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any, ebDealUniqueId?: string | null }> }, leads: { __typename?: 'LeadsConnection', nodes: Array<{ __typename?: 'Lead', nodeId: string, ebDealUniqueId?: string | null, provider?: { __typename?: 'Provider', nodeId: string, id: any, name: string, title: string, phone?: string | null, email: any, engagebay?: any | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } | null }> } }> } } | null };

export type UpdateConsumerMutationVariables = Exact<{
  input: UpdateConsumerInput;
}>;


export type UpdateConsumerMutation = { __typename?: 'Mutation', updateConsumer?: { __typename?: 'UpdateConsumerPayload', consumer?: { __typename?: 'Consumer', nodeId: string, engagebay?: any | null, consultation?: any | null } | null } | null };

export type ConsumersListQueryVariables = Exact<{
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ConsumersListQuery = { __typename?: 'Query', allConsumers?: { __typename?: 'ConsumersConnection', nodes: Array<(
      { __typename?: 'Consumer' }
      & { ' $fragmentRefs'?: { 'ConsumerDataFragment': ConsumerDataFragment } }
    )> } | null };

export type ConsumersByLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type ConsumersByLocationQuery = { __typename?: 'Query', consumersByLocation?: { __typename?: 'ConsumersConnection', nodes: Array<{ __typename?: 'Consumer', id: any, vendors?: any | null, createdAt: any, engagebay?: any | null, account?: { __typename?: 'Account', firstName: string, lastName: string, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', value: any }> } } | null, inquiries: { __typename?: 'InquiriesConnection', nodes: Array<{ __typename?: 'Inquiry', details: any }> } }> } | null };

export type InquiryByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InquiryByIdQuery = { __typename?: 'Query', inquiryById?: { __typename?: 'Inquiry', nodeId: string, id: any, details: any, detailsConfirmed?: any | null, providers?: any | null, flags?: any | null, potentialProviders: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: { __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved?: boolean | null, signed?: boolean | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } | null }> }, inquiryAddresses: { __typename?: 'InquiryAddressesConnection', nodes: Array<{ __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any }> } } | null };

export type UpdateInquiryMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type UpdateInquiryMutation = { __typename?: 'Mutation', updateInquiry?: { __typename?: 'UpdateInquiryPayload', inquiry?: { __typename?: 'Inquiry', nodeId: string, id: any, providers?: any | null, details: any, flags?: any | null } | null } | null };

export type AddInquiryAddressMutationVariables = Exact<{
  input: AddInquiryAddressInput;
}>;


export type AddInquiryAddressMutation = { __typename?: 'Mutation', addInquiryAddress?: { __typename?: 'AddInquiryAddressPayload', inquiry?: { __typename?: 'Inquiry', nodeId: string, inquiryAddresses: { __typename?: 'InquiryAddressesConnection', nodes: Array<{ __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any }> } } | null } | null };

export type UpdateInquiryAddressMutationVariables = Exact<{
  input: UpdateInquiryAddressInput;
}>;


export type UpdateInquiryAddressMutation = { __typename?: 'Mutation', updateInquiryAddress?: { __typename?: 'UpdateInquiryAddressPayload', inquiryAddress?: { __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any, ebDealUniqueId?: string | null, inquiry?: { __typename?: 'Inquiry', nodeId: string, potentialProviders: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: { __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved?: boolean | null, signed?: boolean | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } | null }> } } | null } | null } | null };

export type LeadQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type LeadQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', id: any, nodeId: string, status: LeadStatus, info: any, history: any, transaction: any, createdAt: any, inquiry?: { __typename?: 'Inquiry', consumer?: { __typename?: 'Consumer', account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, avatar?: { __typename?: 'Media', url?: string | null } | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', type: string, value: any }> } } | null } | null } | null } | null };

export type LeadByIdQueryVariables = Exact<{
  input: Scalars['UUID'];
}>;


export type LeadByIdQuery = { __typename?: 'Query', leadById?: { __typename?: 'Lead', id: any, nodeId: string, status: LeadStatus, info: any, history: any, transaction: any, createdAt: any, inquiry?: { __typename?: 'Inquiry', consumer?: { __typename?: 'Consumer', account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, avatar?: { __typename?: 'Media', url?: string | null } | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', type: string, value: any }> } } | null } | null } | null } | null };

export type UpdateLeadMutationVariables = Exact<{
  input: UpdateLeadInput;
}>;


export type UpdateLeadMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: { __typename?: 'Lead', id: any, nodeId: string, status: LeadStatus, info: any, history: any, transaction: any } | null } | null };

export type LinkQueryVariables = Exact<{
  input: Scalars['UUID'];
}>;


export type LinkQuery = { __typename?: 'Query', linkById?: { __typename?: 'Link', path: string, data?: any | null } | null };

export type CityDistanceQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
}>;


export type CityDistanceQuery = { __typename?: 'Query', cityDistance?: number | null };

export type CitiesDistanceQueryVariables = Exact<{
  city1: Scalars['String'];
  state1: Scalars['String'];
  city2: Scalars['String'];
  state2: Scalars['String'];
}>;


export type CitiesDistanceQuery = { __typename?: 'Query', citiesDistance?: number | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginPayload', jwtToken?: any | null } | null };

export type LoginAsMutationVariables = Exact<{
  input: LoginAsInput;
}>;


export type LoginAsMutation = { __typename?: 'Mutation', loginAs?: { __typename?: 'LoginAsPayload', link?: { __typename?: 'Link', id: any } | null } | null };

export type NearestZipQueryVariables = Exact<{
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
}>;


export type NearestZipQuery = { __typename?: 'Query', nearestZip?: any | null };

export type PotentialProviderFragmentFragment = { __typename?: 'Provider', nodeId: string, id: any, name: string, title: string, phone?: string | null, email: any, info: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, syntheticStatus?: string | null, approvalRequested?: any | null, public: boolean, approved?: boolean | null, signed?: boolean | null, docusignStatus?: string | null, docusignSigned?: any | null, bizDev?: boolean | null, image?: { __typename?: 'Media', url?: string | null } | null, transactions: { __typename?: 'ProviderTransactionsConnection', nodes: Array<{ __typename?: 'ProviderTransaction', nodeId: string, address1: string, address2?: string | null, city: string, state: string, zip?: string | null, closeDate: any, closePrice: number, location?: any | null, lookupFailed?: any | null }> }, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } & { ' $fragmentName'?: 'PotentialProviderFragmentFragment' };

export type DealPotentialProvidersQueryVariables = Exact<{
  dealUniqueId: Scalars['String'];
}>;


export type DealPotentialProvidersQuery = { __typename?: 'Query', dealPotentialProviders?: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'PotentialProviderFragmentFragment': PotentialProviderFragmentFragment } }
      ) | null }> } | null };

export type CityStatePotentialProvidersQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
}>;


export type CityStatePotentialProvidersQuery = { __typename?: 'Query', cityStatePotentialProviders?: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'PotentialProviderFragmentFragment': PotentialProviderFragmentFragment } }
      ) | null }> } | null };

export type ZipPotentialProvidersQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type ZipPotentialProvidersQuery = { __typename?: 'Query', zipPotentialProviders?: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'PotentialProviderFragmentFragment': PotentialProviderFragmentFragment } }
      ) | null }> } | null };

export type ProviderDataFragment = { __typename?: 'Provider', nodeId: string, id: any, accountId: any, signed?: boolean | null, engagebay?: any | null, type: ProviderType, name: string, slug?: any | null, title: string, gender?: string | null, phone?: string | null, email: any, info: any, transactionHistory: any, setupComplete?: any | null, approvalRequested?: any | null, approved?: boolean | null, public: boolean, minPrice?: number | null, maxPrice?: number | null, createdAt: any, areaCenter?: any | null, status?: any | null, docusignStatus?: string | null, docusignSigned?: any | null, docusignExpiration?: any | null, profileComplete?: number | null, bizDev?: boolean | null, deletedAt?: any | null, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, suppressMessages?: boolean | null, campaign?: any | null, deletedAt?: any | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any }> } } | null, image?: { __typename?: 'Media', url?: string | null } | null } & { ' $fragmentName'?: 'ProviderDataFragment' };

export type ProviderQueryVariables = Exact<{
  nodeId: Scalars['ID'];
}>;


export type ProviderQuery = { __typename?: 'Query', provider?: (
    { __typename?: 'Provider' }
    & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
  ) | null };

export type ProviderByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProviderByIdQuery = { __typename?: 'Query', providerById?: (
    { __typename?: 'Provider' }
    & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
  ) | null };

export type ProviderBySlugQueryVariables = Exact<{
  slug: Scalars['Slug'];
}>;


export type ProviderBySlugQuery = { __typename?: 'Query', providerBySlug?: (
    { __typename?: 'Provider' }
    & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
  ) | null };

export type UpdateProviderMutationVariables = Exact<{
  input: UpdateProviderInput;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'UpdateProviderPayload', provider?: { __typename?: 'Provider', nodeId: string, id: any, name: string, title: string, slug?: any | null, phone?: string | null, email: any, info: any, transactionHistory: any, setupComplete?: any | null, approvalRequested?: any | null, approved?: boolean | null, public: boolean, minPrice?: number | null, maxPrice?: number | null, docusignStatus?: string | null, image?: { __typename?: 'Media', url?: string | null } | null } | null } | null };

export type ProvidersByLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type ProvidersByLocationQuery = { __typename?: 'Query', providersByLocation?: { __typename?: 'ProvidersConnection', nodes: Array<(
      { __typename?: 'Provider', cities?: any | null, engagebay?: any | null, info: any, account?: { __typename?: 'Account', id: any, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any, verifiedAt?: any | null }> } } | null }
      & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
    )> } | null };

export type ProvidersByCityStateQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
  miles?: InputMaybe<Scalars['BigFloat']>;
}>;


export type ProvidersByCityStateQuery = { __typename?: 'Query', providersByCityState?: { __typename?: 'ProvidersConnection', nodes: Array<{ __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved?: boolean | null, signed?: boolean | null, bizDev?: boolean | null, docusignStatus?: string | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null }> } | null };

export type ProvidersNearestQueryVariables = Exact<{
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
}>;


export type ProvidersNearestQuery = { __typename?: 'Query', providersNearest?: { __typename?: 'ProvidersConnection', nodes: Array<{ __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved?: boolean | null, signed?: boolean | null, bizDev?: boolean | null, docusignStatus?: string | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null }> } | null };

export type ProviderTransactionLocationsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProviderTransactionLocationsQuery = { __typename?: 'Query', providerById?: { __typename?: 'Provider', transactionLocations?: any | null } | null };

export type ProvidersByTransactionLocationQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}>;


export type ProvidersByTransactionLocationQuery = { __typename?: 'Query', providersByTransactionLocation?: { __typename?: 'ProviderTransactionCountsConnection', nodes: Array<{ __typename?: 'ProviderTransactionCount', count?: any | null, provider?: { __typename?: 'Provider', nodeId: string, id: any, name: string, location?: any | null, status?: any | null, syntheticStatus?: string | null, docusignStatus?: string | null, docusignSigned?: any | null, signed?: boolean | null, public: boolean, approved?: boolean | null, engagebay?: any | null, info: any, bizDev?: boolean | null, transactions: { __typename?: 'ProviderTransactionsConnection', nodes: Array<{ __typename?: 'ProviderTransaction', nodeId: string, id: any, address1: string, address2?: string | null, city: string, state: string, zip?: string | null }> }, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string, campaign?: any | null } | null } | null }> } | null };

export type ProvidersQueryVariables = Exact<{
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ProvidersQuery = { __typename?: 'Query', allProviders?: { __typename?: 'ProvidersConnection', nodes: Array<(
      { __typename?: 'Provider' }
      & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
    )> } | null };

export type ProvidersListQueryVariables = Exact<{
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ProvidersListQuery = { __typename?: 'Query', allProviders?: { __typename?: 'ProvidersConnection', nodes: Array<{ __typename?: 'Provider', nodeId: string, id: any, name: string, engagebayId?: string | null, email: any, brokerageName?: string | null, status?: any | null, syntheticStatus?: string | null, signed?: boolean | null, docusignStatus?: string | null, docusignSigned?: any | null, profileComplete?: number | null, location?: any | null, createdAt: any, public: boolean, approved?: boolean | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string, campaign?: any | null } | null }> } | null };

export type RedeemPointsMutationVariables = Exact<{
  input: PointsLedgerRedeemInput;
}>;


export type RedeemPointsMutation = { __typename?: 'Mutation', pointsLedgerRedeem?: { __typename?: 'PointsLedgerRedeemPayload', uuid?: any | null } | null };

export type RemoveAccountMutationVariables = Exact<{
  input: RemoveAccountInput;
}>;


export type RemoveAccountMutation = { __typename?: 'Mutation', removeAccount?: { __typename?: 'RemoveAccountPayload', clientMutationId?: string | null, account?: { __typename?: 'Account', id: any, consumer?: (
        { __typename?: 'Consumer' }
        & { ' $fragmentRefs'?: { 'ConsumerDataFragment': ConsumerDataFragment } }
      ) | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
      ) | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordPayload', clientMutationId?: string | null } | null };

export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordInput;
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword?: { __typename?: 'SetPasswordPayload', clientMutationId?: string | null } | null };

export type TokenLoginMutationVariables = Exact<{
  input: TokenLoginInput;
}>;


export type TokenLoginMutation = { __typename?: 'Mutation', tokenLogin?: { __typename?: 'TokenLoginPayload', jwtToken?: any | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'UpdateAccountPayload', query?: { __typename?: 'Query', viewer?: (
        { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, onboardedBy?: any | null, suppressMessages?: boolean | null }
        & { ' $fragmentRefs'?: { 'ViewerAvatarFragment': ViewerAvatarFragment } }
      ) | null } | null } | null };

export type UpdateAccountListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateAccountListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', firstName: string, lastName: string, campaign?: any | null, nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateConsumerListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateConsumerListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', vendors?: any | null, engagebay?: any | null, providersInArea?: string | null, consultation?: any | null, deletedAt?: any | null, nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateContactListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateContactListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', type: string, value: any, nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateInquiryListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateInquiryListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', details: any, detailsConfirmed?: any | null, matches?: Array<any | null> | null, providers?: any | null, flags?: any | null, ebDealUniqueId?: string | null, nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateInquiryAddressListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateInquiryAddressListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', address: string, latitude: any, longitude: any, price?: any | null, ebDealUniqueId?: string | null, nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateInvitationListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateInvitationListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', firstName: string, lastName: string, email: any, phone?: string | null, info?: any | null, nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateLeadListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateLeadListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', status: LeadStatus, info: any, history: any, transaction: any, ebDealUniqueId?: string | null, nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateProviderListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateProviderListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', type: ProviderType, name: string, gender?: string | null, title: string, slug?: any | null, phone?: string | null, email: any, info: any, transactionHistory: any, approved?: boolean | null, public: boolean, tier?: number | null, setupComplete?: any | null, profileComplete?: number | null, approvalRequested?: any | null, minPrice?: number | null, maxPrice?: number | null, status?: any | null, syntheticStatus?: string | null, bizDev?: boolean | null, languages?: Array<string | null> | null, specialties?: Array<string | null> | null, nickname?: string | null, pronouns?: string | null, geoJson?: any | null, areaCenter?: any | null, engagebay?: any | null, engagebayId?: string | null, deletedAt?: any | null, nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateTransactionLocationMutationVariables = Exact<{
  input: UpdateTransactionLocationInput;
}>;


export type UpdateTransactionLocationMutation = { __typename?: 'Mutation', updateTransactionLocation?: { __typename?: 'UpdateTransactionLocationPayload', providerTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, lookupFailed?: any | null, location?: any | null } | null } | null };

export type UpdateTransactionLocationLookupFailedMutationVariables = Exact<{
  input: UpdateTransactionLocationLookupFailedInput;
}>;


export type UpdateTransactionLocationLookupFailedMutation = { __typename?: 'Mutation', updateTransactionLocationLookupFailed?: { __typename?: 'UpdateTransactionLocationLookupFailedPayload', providerTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, lookupFailed?: any | null, location?: any | null } | null } | null };

export type GetNextProviderTransactionQueryVariables = Exact<{
  t: Scalars['String'];
}>;


export type GetNextProviderTransactionQuery = { __typename?: 'Query', getNextProviderTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, id: any, address1: string, address2?: string | null, city: string, state: string, zip?: string | null, location?: any | null, lookupFailed?: any | null } | null };

export type UpdateProviderTransactionByIdMutationVariables = Exact<{
  input: UpdateProviderTransactionByIdInput;
}>;


export type UpdateProviderTransactionByIdMutation = { __typename?: 'Mutation', updateProviderTransactionById?: { __typename?: 'UpdateProviderTransactionPayload', providerTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, id: any, address1: string, address2?: string | null, city: string, state: string, zip?: string | null, location?: any | null, lookupFailed?: any | null } | null } | null };

export type UserActivityListenerSubscriptionVariables = Exact<{
  topic: Scalars['String'];
}>;


export type UserActivityListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Alert', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Note', nodeId: string } | { __typename?: 'OpenaiAssistant', nodeId: string } | { __typename?: 'OpenaiMessage', nodeId: string } | { __typename?: 'OpenaiRun', nodeId: string } | { __typename?: 'OpenaiRunStep', nodeId: string } | { __typename?: 'OpenaiThread', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'PromoCode', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'Review', nodeId: string } | { __typename?: 'UserActivity', instanceId: string, path: string, data?: any | null, createdAt: any, nodeId: string, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string } | null } | null } };

export type CreateUserActivityMutationVariables = Exact<{
  input: CreateUserActivityInput;
}>;


export type CreateUserActivityMutation = { __typename?: 'Mutation', createUserActivity?: { __typename?: 'CreateUserActivityPayload', userActivity?: { __typename?: 'UserActivity', nodeId: string, instanceId: string, path: string, data?: any | null, createdAt: any, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string } | null } | null } | null };

export type UserActivitiesQueryQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type UserActivitiesQueryQuery = { __typename?: 'Query', userActivities?: { __typename?: 'UserActivitiesConnection', nodes: Array<{ __typename?: 'UserActivity', nodeId: string, instanceId: string, path: string, data?: any | null, createdAt: any, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string } | null }> } | null };

export type ViewerAvatarFragment = { __typename?: 'Account', avatar?: { __typename?: 'Media', nodeId: string, url?: string | null, meta?: any | null } | null } & { ' $fragmentName'?: 'ViewerAvatarFragment' };

export type ViewerContactsFragment = { __typename?: 'Account', contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', id: any, nodeId: string, type: string, value: any, verifiedAt?: any | null, verificationAttempts?: number | null }> } } & { ' $fragmentName'?: 'ViewerContactsFragment' };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: (
    { __typename?: 'Account', nodeId: string, id: any, admin?: boolean | null, firstName: string, lastName: string }
    & { ' $fragmentRefs'?: { 'ViewerAvatarFragment': ViewerAvatarFragment;'ViewerContactsFragment': ViewerContactsFragment } }
  ) | null };

export type ZipGeoJsonQueryVariables = Exact<{
  zip?: InputMaybe<Scalars['String']>;
}>;


export type ZipGeoJsonQuery = { __typename?: 'Query', zipGeoJson?: any | null };

export const ConsumerDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsumerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Consumer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointsAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"pointsLedger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountByCreatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<ConsumerDataFragment, unknown>;
export const PotentialProviderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PotentialProviderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"closePrice"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<PotentialProviderFragmentFragment, unknown>;
export const ProviderDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"setupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"areaCenter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"docusignExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<ProviderDataFragment, unknown>;
export const ViewerAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewerAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]} as unknown as DocumentNode<ViewerAvatarFragment, unknown>;
export const ViewerContactsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewerContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"verificationAttempts"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerContactsFragment, unknown>;
export const AccountByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountByIdQuery, AccountByIdQueryVariables>;
export const AdminUpdateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUpdateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUpdateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminUpdateAccountMutation, AdminUpdateAccountMutationVariables>;
export const AgentsByCityStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgentsByCityState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentsByCityState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<AgentsByCityStateQuery, AgentsByCityStateQueryVariables>;
export const AutocompleteLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutocompleteLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"zipCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}}}]}]}}]} as unknown as DocumentNode<AutocompleteLocationQuery, AutocompleteLocationQueryVariables>;
export const CityGeoJsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityGeoJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityGeoJson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}]}}]} as unknown as DocumentNode<CityGeoJsonQuery, CityGeoJsonQueryVariables>;
export const ConsumerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsumerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"undeliverableAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"pointsLedger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountByCreatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"providersInArea"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<ConsumerByIdQuery, ConsumerByIdQueryVariables>;
export const UpdateConsumerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConsumer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConsumerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConsumer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConsumerMutation, UpdateConsumerMutationVariables>;
export const ConsumersListDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsumersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allConsumers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsumerData"}}]}}]}}]}},...ConsumerDataFragmentDoc.definitions]} as unknown as DocumentNode<ConsumersListQuery, ConsumersListQueryVariables>;
export const ConsumersByLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsumersByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumersByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"email","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConsumersByLocationQuery, ConsumersByLocationQueryVariables>;
export const InquiryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InquiryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"potentialProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InquiryByIdQuery, InquiryByIdQueryVariables>;
export const UpdateInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryMutation, UpdateInquiryMutationVariables>;
export const AddInquiryAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddInquiryAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddInquiryAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addInquiryAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddInquiryAddressMutation, AddInquiryAddressMutationVariables>;
export const UpdateInquiryAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInquiryAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInquiryAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInquiryAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"potentialProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryAddressMutation, UpdateInquiryAddressMutationVariables>;
export const LeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Lead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadQuery, LeadQueryVariables>;
export const LeadByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadByIdQuery, LeadByIdQueryVariables>;
export const UpdateLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLeadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadMutation, UpdateLeadMutationVariables>;
export const LinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Link"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<LinkQuery, LinkQueryVariables>;
export const CityDistanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityDistance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityDistance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}]}]}}]} as unknown as DocumentNode<CityDistanceQuery, CityDistanceQueryVariables>;
export const CitiesDistanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CitiesDistance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"citiesDistance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city1"}}},{"kind":"Argument","name":{"kind":"Name","value":"state1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state1"}}},{"kind":"Argument","name":{"kind":"Name","value":"city2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city2"}}},{"kind":"Argument","name":{"kind":"Name","value":"state2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state2"}}}]}]}}]} as unknown as DocumentNode<CitiesDistanceQuery, CitiesDistanceQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwtToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LoginAsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginAs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginAsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginAs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LoginAsMutation, LoginAsMutationVariables>;
export const NearestZipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NearestZip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearestZip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}]}]}}]} as unknown as DocumentNode<NearestZipQuery, NearestZipQueryVariables>;
export const DealPotentialProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DealPotentialProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dealUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dealPotentialProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dealUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dealUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PotentialProviderFragment"}}]}}]}}]}}]}},...PotentialProviderFragmentFragmentDoc.definitions]} as unknown as DocumentNode<DealPotentialProvidersQuery, DealPotentialProvidersQueryVariables>;
export const CityStatePotentialProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityStatePotentialProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityStatePotentialProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PotentialProviderFragment"}}]}}]}}]}}]}},...PotentialProviderFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CityStatePotentialProvidersQuery, CityStatePotentialProvidersQueryVariables>;
export const ZipPotentialProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZipPotentialProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipPotentialProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PotentialProviderFragment"}}]}}]}}]}}]}},...PotentialProviderFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ZipPotentialProvidersQuery, ZipPotentialProvidersQueryVariables>;
export const ProviderDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Provider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProviderQuery, ProviderQueryVariables>;
export const ProviderByIdDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProviderByIdQuery, ProviderByIdQueryVariables>;
export const ProviderBySlugDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Slug"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProviderBySlugQuery, ProviderBySlugQueryVariables>;
export const UpdateProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"setupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const ProvidersByLocationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}},{"kind":"Field","name":{"kind":"Name","value":"cities"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}}]}}]}}]}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProvidersByLocationQuery, ProvidersByLocationQueryVariables>;
export const ProvidersByCityStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersByCityState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"miles"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersByCityState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"miles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"miles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersByCityStateQuery, ProvidersByCityStateQueryVariables>;
export const ProvidersNearestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersNearest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersNearest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersNearestQuery, ProvidersNearestQueryVariables>;
export const ProviderTransactionLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderTransactionLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionLocations"}}]}}]}}]} as unknown as DocumentNode<ProviderTransactionLocationsQuery, ProviderTransactionLocationsQueryVariables>;
export const ProvidersByTransactionLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersByTransactionLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersByTransactionLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersByTransactionLocationQuery, ProvidersByTransactionLocationQueryVariables>;
export const ProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Providers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProvidersQuery, ProvidersQueryVariables>;
export const ProvidersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"engagebayId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"brokerageName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersListQuery, ProvidersListQueryVariables>;
export const RedeemPointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedeemPoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PointsLedgerRedeemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointsLedgerRedeem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<RedeemPointsMutation, RedeemPointsMutationVariables>;
export const RemoveAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsumerData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}}]}}]}},...ConsumerDataFragmentDoc.definitions,...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<RemoveAccountMutation, RemoveAccountMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<SetPasswordMutation, SetPasswordMutationVariables>;
export const TokenLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TokenLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TokenLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwtToken"}}]}}]}}]} as unknown as DocumentNode<TokenLoginMutation, TokenLoginMutationVariables>;
export const UpdateAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"onboardedBy"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewerAvatar"}}]}}]}}]}}]}},...ViewerAvatarFragmentDoc.definitions]} as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateAccountListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateAccountListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Account","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountListenerSubscription, UpdateAccountListenerSubscriptionVariables>;
export const UpdateConsumerListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateConsumerListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Consumer","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Consumer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"providersInArea"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConsumerListenerSubscription, UpdateConsumerListenerSubscriptionVariables>;
export const UpdateContactListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateContactListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Contact","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateContactListenerSubscription, UpdateContactListenerSubscriptionVariables>;
export const UpdateInquiryListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateInquiryListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Inquiry","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Inquiry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"matches"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryListenerSubscription, UpdateInquiryListenerSubscriptionVariables>;
export const UpdateInquiryAddressListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateInquiryAddressListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:InquiryAddress","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InquiryAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryAddressListenerSubscription, UpdateInquiryAddressListenerSubscriptionVariables>;
export const UpdateInvitationListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateInvitationListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Invitation","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invitation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInvitationListenerSubscription, UpdateInvitationListenerSubscriptionVariables>;
export const UpdateLeadListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateLeadListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Lead","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Lead"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadListenerSubscription, UpdateLeadListenerSubscriptionVariables>;
export const UpdateProviderListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateProviderListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Provider","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"setupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"areaCenter"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"engagebayId"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProviderListenerSubscription, UpdateProviderListenerSubscriptionVariables>;
export const UpdateTransactionLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTransactionLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTransactionLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTransactionLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTransactionLocationMutation, UpdateTransactionLocationMutationVariables>;
export const UpdateTransactionLocationLookupFailedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTransactionLocationLookupFailed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTransactionLocationLookupFailedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTransactionLocationLookupFailed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTransactionLocationLookupFailedMutation, UpdateTransactionLocationLookupFailedMutationVariables>;
export const GetNextProviderTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNextProviderTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"t"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNextProviderTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"t"},"value":{"kind":"Variable","name":{"kind":"Name","value":"t"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}}]}}]}}]} as unknown as DocumentNode<GetNextProviderTransactionQuery, GetNextProviderTransactionQueryVariables>;
export const UpdateProviderTransactionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProviderTransactionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProviderTransactionByIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProviderTransactionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProviderTransactionByIdMutation, UpdateProviderTransactionByIdMutationVariables>;
export const UserActivityListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserActivityListener"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topic"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserActivityListenerSubscription, UserActivityListenerSubscriptionVariables>;
export const CreateUserActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserActivityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserActivityMutation, CreateUserActivityMutationVariables>;
export const UserActivitiesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserActivitiesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserActivitiesQueryQuery, UserActivitiesQueryQueryVariables>;
export const ViewerDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewerAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewerContacts"}}]}}]}},...ViewerAvatarFragmentDoc.definitions,...ViewerContactsFragmentDoc.definitions]} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const ZipGeoJsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZipGeoJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipGeoJson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zipCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}]}]}}]} as unknown as DocumentNode<ZipGeoJsonQuery, ZipGeoJsonQueryVariables>;